<template>
  <div class="home-section-wrap-landing">
    <section class="home-section-landing" style="display: block !important;" id="home-section-landing">
      <div class="container">
        <div style="margin-bottom: .5rem;">
          <button class="btn-success btn-blue-success" style="padding: .35rem .8rem; border-radius: .5rem;" @click="$router.go(-1)">← Назад</button>
        </div>
        <h1 class="module-title" style="font-size: 18px; font-weight: bold">Создание акта выполненных работ и услуг</h1>
        <br>
        <div class="wizard-nav">
          <div :class="get_arrow_steps_class()">
            <template v-for="(step_i, index) in this.all_steps">
              <div :class="'step ' + curr_class(index + 1)" v-show="new_act.type === 1 ||
                  new_act.type === 4 ||
                  (new_act.type === 2 && (
                    new_act.inner_type !== 'Капстроительство' || index < 4
                  )) ||
                  (new_act.type === 3 && (index < 4 || new_act.dbikrs_inner_type !== 'КРС'))
              ">
                <span class="step-badge">
                  <span v-if="curr_class(index + 1) === 'done'">✓</span>
                  <span v-else>{{ index + 1 }}</span>
                </span>
                <span class="step-info">
                  <span class="step-num-label">Шаг {{ index + 1 }}</span>
                  <span class="step-name-label">{{ step_i.name }}</span>
                </span>
              </div>
            </template>
          </div>
          <div :class="prev_next_btn_class()" style="display: flex; gap: .75rem; margin-top: .75rem">
            <a v-if="this.curr_module !== 1" @click="prevStep()">
              <button class="btn-success btn-blue-success" style="width: 160px; padding: .5rem; border-radius: .5rem">
                ← Вернуться
              </button>
            </a>
            <a v-if="all_required_exist" @click="nextStep()">
              <button class="btn-success" style="width: 160px; padding: .5rem; border-radius: .5rem">
                <span v-if="this.new_act.type === 1 && this.curr_module === 3">Сохранить</span>
                <span v-else-if="this.new_act.type === 2 && this.curr_module === 4 && this.new_act.inner_type === 'Капстроительство'">Сохранить</span>
                <span v-else-if="this.new_act.type === 2 && this.curr_module === 5">Сохранить</span>
                <span v-else-if="this.new_act.type === 3 && this.curr_module === 4">Сохранить</span>
                <span v-else-if="this.new_act.type === 4 && this.curr_module === 4">Сохранить</span>
                <span v-else-if="this.curr_module === 5">Сохранить</span>
                <span v-else>Продолжить →</span>
              </button>
            </a>
          </div>
        </div>
        <div class="aiia-wizard-step" style="width: 100%; margin-bottom: 30px">
          <div>
            <h2>
              <span class="circle-number">{{ curr_module }}</span>
              <span style="font-size: 20px;">Инструкция</span>
              <span style="color: #23468c"> ({{ this.all_steps[curr_module - 1].name }})</span>
            </h2>
            <div class="step-content" style="padding-top: 0.7rem">
              <p>
                {{ this.all_steps[curr_module - 1].instruction }}
                <span v-if="this.curr_module === 3 && this.new_act.type === 1 || this.curr_module === 3 && this.new_act.type === 4 || this.curr_module === 3 && this.new_act.type === 3 && (this.new_act.dbikrs_inner_type === 'КРС' || this.new_act.dbikrs_inner_type === 'Супервайзер') || this.curr_module === 3 && this.new_act.type === 2 && this.new_act.inner_type !== 'Капстроительство'">
                  . Так же, вы можете
                  <a class="custom-link" download="Шаблон для загрузки акта.xlsx" @click="showDownloadTemplate">скачать шаблон (excel)</a>
                  , заполнить его и
                  <input type="file" name="file" id="file" class="inputfile" :ref="'file_template'" v-on:change="uploadTemplate">
                  <label for="file" class="upload-from-xls">загрузить обратно</label>
                  . Либо
                  <input type="file" name="file_galaktika" id="file_galaktika" class="inputfile" :ref="'file_template_galaktika'" v-on:change="uploadTemplateGalaktika">
                  <label for="file_galaktika" class="upload-from-xls">загрузить из Галактики (Р-1)</label>
                </span>
                <span v-else-if="this.new_act.type === 2 &&
                    (
                      (this.curr_module === 4 && this.new_act.inner_type === 'Капстроительство') ||
                      (this.curr_module === 5 && this.new_act.inner_type === 'Капремонт')
                    )">
                  . Так же, вы можете
                  <a class="custom-link" download="Шаблон для загрузки расшифровки по ДКС (капстроительство).xlsx" @click="showDownloadTemplateDKSRF">скачать шаблон (excel)</a>
                  , заполнить его и
                  <input type="file" name="file" id="file" class="inputfile" :ref="'file_template'" v-on:change="uploadTemplateDKSRF">
                  <label for="file" class="upload-from-xls">загрузить обратно</label>
                </span>
                <span v-else-if="this.curr_module === 4 && this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'КРС'">
                  . Так же, вы можете
                  <a class="custom-link" @click="showDownloadTemplateKRS">скачать шаблон (excel)</a>
                  , заполнить его и
                  <input type="file" name="file_krs" id="file_krs" class="inputfile" :ref="'file_template_krs'" v-on:change="uploadTemplateKRS">
                  <label for="file_krs" class="upload-from-xls">загрузить обратно</label>
                </span>
              </p>

              <modal name="download-template-modal">
                <div class="modal-inner">
                  <h2>Формирование шаблона для загрузки акта</h2>
                  <input class="input-field-template" type="number" min="1" placeholder="Введите количество заголовков" v-model="template_header_count">
                  <input class="input-field-template" type="number" min="1" placeholder="Введите количество строк на заголовок" v-model="template_row_count" style="margin-top: .5rem;">
                  <button class="upload-from-xls" @click="downloadTemplate" v-if="template_row_count !== '' && template_header_count !== ''">Скачать шаблон</button>
                </div>
              </modal>
              <modal name="download-template-modal-dks-rf">
                <div class="modal-inner">
                  <h2>Формирование шаблона для загрузки расшифровки по акту</h2>
                  <input class="input-field-template" type="number" placeholder="Введите количество строк в расшифровке" v-model="template_row_count">
                  <button class="upload-from-xls" @click="downloadTemplateDKSRF" v-if="template_row_count !== ''">Скачать шаблон</button>
                </div>
              </modal>
              <modal name="download-template-modal-krs">
                <div class="modal-inner">
                  <h2>Формирование шаблона КРС</h2>
                  <input class="input-field-template" type="number" min="1" placeholder="Введите количество строк" v-model="template_row_count">
                  <button class="upload-from-xls" @click="downloadTemplateKRS" v-if="template_row_count !== ''">Скачать шаблон</button>
                </div>
              </modal>
            </div>
          </div>
        </div>
        <div class="categories-container">
          <div v-show="this.curr_module === 1" class="flex-start-column gap-2r">
            <div class="flex-space-between gap-1r">
              <div class="flex-start-column div-half gap-half">
                <label>Номер акта</label>
                <input class="input-act-params" placeholder="Введите номер акта*" v-model="new_act.number">
              </div>
              <div class="flex-start-column div-full gap-half">
                <label>Наименование акта</label>
                <input class="input-act-params" placeholder="Введите наименование акта*" v-model="new_act.name">
              </div>
              <div class="flex-start-column div-half gap-half">
                <label>Дата акта</label>
                <input class="input-act-params" placeholder="Введите дату акта*" v-model="new_act.act_date"
                       v-on:focusout="check_act_date" type='date'>
              </div>
            </div>
            <div class="flex-space-between gap-1r">
              <div class="flex-start-column div-full gap-half">
                <label>Договор</label>
                <select class="input-act-params" v-model="new_act.contract.id" @change="change_contract()">
                  <option value="">Выберите договор оказания работ / услуг*</option>
                  <option v-for="(contract, index) in this.contracts" :key="index" :title="contract.name"
                          :value="contract.id">
                    ({{ contract.date_from }}) №{{ contract.number }} {{ contract.short_name }}
                  </option>
                </select>
              </div>
              <div class="flex-start-column div-full gap-half" v-if="new_act.type === 3">
                <label>Тип работ ДБиКРС</label>
                <select class="input-act-params" v-model="new_act.dbikrs_inner_type" @change="change_steps_dbikrs">
                  <option v-for="(ngdu_i, index) in this.dbikrs_inner_type_list" :key="index" :value="ngdu_i">{{ ngdu_i }}</option>
                </select>
              </div>
              <div class="flex-start-column div-half gap-half" v-if="new_act.type === 3">
                <label>Месяц услуг</label>
                <select class="input-act-params" v-model="new_act.act_month">
                  <option value="">Выберите месяц услуг</option>
                  <option v-for="(month, index) in this.months_list" :key="index" :value="month">{{ month }}</option>
                </select>
              </div>
              <div class="flex-start-column div-full gap-half" v-if="new_act.type === 4">
                <label>Тип работ ПТО ПД</label>
                <select class="input-act-params" v-model="new_act.ptopd_inner_type" @change="change_ptopd_type">
                  <option v-for="(t, index) in this.ptopd_inner_type_list" :key="index" :value="t">{{ t }}</option>
                </select>
              </div>
              <div class="flex-start-column div-half gap-half" v-if="new_act.type === 4">
                <label>Месяц услуг</label>
                <select class="input-act-params" v-model="new_act.act_month">
                  <option value="">Выберите месяц услуг</option>
                  <option v-for="(month, index) in this.months_list" :key="index" :value="month">{{ month }}</option>
                </select>
              </div>
              <div class="flex-start-column div-half gap-half" v-if="new_act.type !== 2">
                <label>Месторождение</label>
                <select class="input-act-params" v-model="new_act.ngdu">
                  <option v-for="(ngdu_i, index) in this.ngdu_list" :key="index" :value="ngdu_i">{{ ngdu_i }}</option>
                </select>
              </div>
            </div>
            <div class="flex-space-between gap-1r" v-if="new_act.type === 2">
              <div class="flex-start-column div-half gap-half">
                <label>Месторождение</label>
                <select class="input-act-params" v-model="new_act.ngdu">
                  <option v-for="(ngdu_i, index) in this.ngdu_list" :key="index" :value="ngdu_i">{{ ngdu_i }}</option>
                </select>
              </div>
              <div class="flex-start-column div-full gap-half">
                <label>Тип работ ДКС</label>
                <select class="input-act-params" v-model="new_act.inner_type" @change="change_steps">
                  <option v-for="(ngdu_i, index) in this.inner_type_list" :key="index" :value="ngdu_i">{{ ngdu_i }}</option>
                </select>
              </div>
              <div class="flex-start-column div-half gap-half">
                <label>Месяц услуг</label>
                <select class="input-act-params" v-model="new_act.act_month">
                  <option value="">Выберите месяц услуг</option>
                  <option v-for="(month, index) in this.months_list" :key="index" :value="month">{{ month }}</option>
                </select>
              </div>
            </div>
          </div>
          <div v-show="this.curr_module === 2" class="flex-start-column gap-2r">
            <div class="dropzone">
              <input type="file" class="input-field" id="input-field-multiple" ref="files_additional" multiple
                     accept=".pdf, image/png, image/jpeg, .xls, .xlsx, .zip, .rar" @change="reuploadVl1"/>
              <div v-if="!new_act.uploading" class="call-to-action">
                Перетащите файлы сюда или нажмите, чтобы загрузить
                <p>
                  <small>максимальный размер файлов: 5MB</small><br>
                  <small>максимальный размер всех файлов: не больше 200 мб</small>
                </p>
                <p>
                  <small>типы загружаемых файлов: .pdf, .png, .jpg, .jpeg, .xls, .xlsx, .zip, .rar</small>
                </p>
              </div>
              <div v-if="new_act.uploading" class="uploaded-msg">
                Файлы успешно загружены
              </div>
            </div>
            <modal name="file-modal-multiple">
              <div class="modal-inner">
                <div>Предупреждение: Следует загружать следующие типы файлов: pdf, png, jpg, jpeg, xls, xlsx, zip, rar</div>
                <button @click="closeModalMultuple">Понятно</button>
              </div>
            </modal>
            <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 1rem"
                 v-for="(double_file, index) in new_act.double_files" :key="index">
              <div class="dropzone">
                <input type="file" class="input-field" :id="'input-field-d1-' + index" :ref="'file_d1_' + index"
                       accept="image/png, image/jpeg" @change="reuploadVl_d1(index)"/>
                <div v-if="!double_file.uploading_d1" class="call-to-action">
                  Перетащите фото сюда или нажмите, чтобы загрузить фото ДО ({{ index + 1 }})
                  <p>
                    <small>максимальный размер файла: 5MB</small>
                  </p>
                  <p>
                    <small>типы загружаемого файла: .png, .jpg, .jpeg</small>
                  </p>
                </div>
                <div v-if="double_file.uploading_d1" class="uploaded-msg">
                  Файл ДО ({{ index + 1 }}) успешно загружен
                </div>
                <modal :name="'file-modal-d1-' + index">
                  <div class="modal-inner">
                    <div>Предупреждение: Следует загружать следующие типы файлов: png, jpg, jpeg</div>
                    <button @click="closeModalD1(index)">Понятно</button>
                  </div>
                </modal>
              </div>
              <div class="dropzone">
                <input type="file" class="input-field" :id="'input-field-d2-' + index" :ref="'file_d2_' + index"
                       accept="image/png, image/jpeg" @change="reuploadVl_d2(index)"/>
                <div v-if="!double_file.uploading_d2" class="call-to-action">
                  Перетащите фото сюда или нажмите, чтобы загрузить фото ПОСЛЕ ({{ index + 1 }})
                  <p>
                    <small>максимальный размер файла: 5MB</small>
                  </p>
                  <p>
                    <small>типы загружаемого файла: .png, .jpg, .jpeg</small>
                  </p>
                </div>
                <div v-if="double_file.uploading_d2" class="uploaded-msg">
                  Файл ПОСЛЕ ({{ index + 1 }}) успешно загружен
                </div>
                <modal :name="'file-modal-d2-' + index">
                  <div class="modal-inner">
                    <div>Предупреждение: Следует загружать следующие типы файлов: png, jpg, jpeg</div>
                    <button @click="closeModalD2(index)">Понятно</button>
                  </div>
                </modal>
              </div>
            </div>
            <button @click="add_double_file" class="add_double_file">Добавить фото до/после</button>
          </div>
          <div v-show="this.curr_module === 3 && (this.new_act.type === 1 || this.new_act.type === 4 || this.new_act.type === 3 && (this.new_act.dbikrs_inner_type === 'КРС' || this.new_act.dbikrs_inner_type === 'Супервайзер') || this.new_act.type === 2 && this.new_act.inner_type !== 'Капстроительство')"
               class="flex-start-column gap-2r">
            <table class="m-table-act" id="price1" style="border: none">
              <tr>
                <th rowspan="2">№П/П</th>
                <th rowspan="2" colspan="12" >Наименование работ (услуг) (в разрезе их подвидов в соответствии с
                  технической спецификацией, заданием, графиком выполнения работ (услуг) при их наличии)
                </th>
                <th rowspan="2">Дата выполнения работ (оказания услуг)**</th>
                <th rowspan="2" style="width: 180px">Сведения об отчете о научных исследованиях, маркетинговых,
                  консультационных и прочих услугах (дата, номер, количество страниц) (при их наличии)***
                </th>
                <th rowspan="2" >Единица измерения</th>
                <th colspan="5" rowspan="1">Выполнено работ (оказано услуг)</th>
                <th rowspan="2" class="no-border-right"></th>
              </tr>
              <tr>
                <th>Количество</th>
                <th>Цена за единицу без НДС</th>
                <th>Стоимость без НДС</th>
                <th>Сумма НДС</th>
                <th>Сумма с НДС</th>
              </tr>
              <tr>
                <template v-for="i in [1,2,3,4,5,6,7,8,9,10]">
                  <td v-if="i === 2" colspan="12">{{ i }}</td>
                  <td v-else>{{ i }}</td>
                </template>
                <td class="no-border-right"></td>
              </tr>
              <template v-for="(row, index) in new_act.rows">
                <tr v-if="row.row_type === '2'">
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input v-model="row.val1" placeholder="Код бюдж. классиф." title="Код бюдж. классиф." class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val2" placeholder="Код услуги/работы" title="Код услуги/работы" class="m-input-cell required-cell"/>
                  </td>
                  <td colspan="10">
                    <input v-model="row.work_name" placeholder="Введите наименование услуг/работ" class="m-input-cell required-cell"/>
                  </td>
                  <td v-if="row.double_date">
                    <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                           style="width: 50%; float: left; font-size: xx-small"/>
                    <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                           style="width: 50%; border-left: 1px solid gray; float: right; font-size: xx-small"/>
                  </td>
                  <td v-else>
                    <input v-model="row.row_date" class="m-input-cell required-cell" type="date"/>
                  </td>
                  <td><input v-model="row.research_report" class="m-input-cell"/></td>
                  <td><input v-model="row.measure_unit" class="m-input-cell required-cell"/></td>
                  <td>
                    <input v-model="row.count" @change="auto_calc_mmg(index)" min="0" type="number" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.unit_price)" @focus="$event.target.value = row.unit_price" @change="row.unit_price = parseFormattedNum($event.target.value); auto_calc_mmg(index)" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.total)" @focus="$event.target.value = row.total" @change="row.total = parseFormattedNum($event.target.value); auto_calc_mmg(index, 1)" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.nds)" @focus="$event.target.value = row.nds" @change="row.nds = parseFormattedNum($event.target.value); auto_calc_mmg(index, 2)" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.total_with_nds)" @focus="$event.target.value = row.total_with_nds" @change="row.total_with_nds = parseFormattedNum($event.target.value); auto_calc_mmg(index, 3)" class="m-input-cell"/>
                  </td>
                  <td class="no-border-right"><button @click="rm_row_index(index)" type="button" class="rm_row_btn_small" title="Убрать строку">-</button></td>
                </tr>
                <tr v-else>
                  <td>{{ index + 1 }}</td>
                  <td>
                    <input v-model="row.val1" class="m-input-cell" readonly style="background:#f0f0f0; cursor:default;"/>
                  </td>
                  <td>
                    <input v-model="row.val2" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val3" class="m-input-cell" readonly style="background:#f0f0f0; cursor:default;"/>
                  </td>
                  <td>
                    <input v-model="row.val4" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val5" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val6" class="m-input-cell" readonly style="background:#f0f0f0; cursor:default;"/>
                  </td>
                  <td>
                    <input v-model="row.val7" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val8" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val9" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val10" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val11" class="m-input-cell required-cell"/>
                  </td>
                  <td>
                    <input v-model="row.val12" class="m-input-cell required-cell"/>
                  </td>
                  <td v-if="row.double_date">
                    <input v-model="row.start_date" class="m-input-cell required-cell" type="date"
                           style="width: 50%; float: left; font-size: xx-small"/>
                    <input v-model="row.end_date" class="m-input-cell required-cell" type="date"
                           style="width: 50%; border-left: 1px solid gray; float: right; font-size: xx-small"/>
                  </td>
                  <td v-else>
                    <input v-model="row.row_date" class="m-input-cell required-cell" type="date"/>
                  </td>
                  <td><input v-model="row.research_report" class="m-input-cell"/></td>
                  <td><input v-model="row.measure_unit" class="m-input-cell required-cell"/></td>
                  <td>
                    <input v-model="row.count" @change="auto_calc_mmg(index)" min="0" type="number" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.unit_price)" @focus="$event.target.value = row.unit_price" @change="row.unit_price = parseFormattedNum($event.target.value); auto_calc_mmg(index)" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.total)" @focus="$event.target.value = row.total" @change="row.total = parseFormattedNum($event.target.value); auto_calc_mmg(index, 1)" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.nds)" @focus="$event.target.value = row.nds" @change="row.nds = parseFormattedNum($event.target.value); auto_calc_mmg(index, 2)" class="m-input-cell"/>
                  </td>
                  <td>
                    <input type="text" :value="prettyPrice(row.total_with_nds)" @focus="$event.target.value = row.total_with_nds" @change="row.total_with_nds = parseFormattedNum($event.target.value); auto_calc_mmg(index, 3)" class="m-input-cell"/>
                  </td>
                  <td class="no-border-right"><button @click="rm_row_index(index)" type="button" class="rm_row_btn_small" title="Убрать строку">-</button></td>
                </tr>
              </template>
              <tr>
                <td colspan="21">
                  <button @click="showAddRowModal" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                  <modal name="add-row-modal" :height="400">
                    <h3 class="modal-title" style="padding: 1rem">Выберите тип даты строки акта</h3>
                    <div class="modal-inner-short" style="text-align: left; width: 100%">
                      <div class="modal-info" style="width: inherit">
                        <select class="input-field-default" id="row-type"
                                style="margin-left: 15%; margin-right: 15%; width: 70%"
                                v-on:change="change_row_type()">
                          <option value="" selected>Выберите тип строки*</option>
                          <option value="2">Заголовок</option>
                          <option value="1">Строка</option>
                        </select>
                      </div>
                      <div class="modal-info" style="width: inherit">
                        <select class="input-field-default" id="row-date-type"
                                style="margin-left: 15%; margin-right: 15%; width: 70%"
                                v-on:change="change_row_date_type()">
                          <option value="">Выберите тип даты строки*</option>
                          <option value="2">Период оказания работ / услуг</option>
                          <option value="1" selected>Дата оказания работ / услуг</option>
                        </select>
                      </div>
                      <div style="position: absolute; bottom: 0; width: 100%; padding: 1rem">
                        <button class="btn-success input-field-default" style="border-radius: 5px;" type="button"
                                v-if="this.row_date_type !== '' && this.row_type !== ''" @click="add_row">Добавить строку
                        </button>
                      </div>
                    </div>
                  </modal>
                </td>
                <td class="no-border-right"></td>
              </tr>
              <tr>
                <template v-for="i in [1,2,3,4,5,6,7]">
                  <td style="height: 35px" v-if="i === 1" colspan="15"></td>
                  <td style="height: 35px" v-else-if="i === 2">Итого:</td>
                  <td style="height: 35px; padding: 0" v-else-if="i === 3"><input v-model.number="new_act.total_count" type="number" class="m-input-cell" style="height: 100%" placeholder=""/></td>
                  <td style="height: 35px" v-else-if="i === 4">X</td>
                  <td style="height: 35px" v-else-if="i === 5">{{ prettyPrice(mmg_row_totals('total')) }}</td>
                  <td style="height: 35px" v-else-if="i === 6">{{ prettyPrice(mmg_row_totals('nds')) }}</td>
                  <td style="height: 35px" v-else-if="i === 7">{{ prettyPrice(mmg_row_totals('total_with_nds')) }}</td>
                </template>
                <td class="no-border-right"></td>
              </tr>

              <tr>
                <th colspan="21" rowspan="3"
                    style="text-align: center; font-size: small; padding-top: 0; padding-bottom: 0">
                  <p>*Применяется для приемки-передачи выполненных работ (оказанных услуг), за исключением
                    строительно-монтажных работ.</p>
                  <p>**Заполняется в случае, если даты выполненных работ (оказанных услуг) приходятся на различные
                    периоды, а также в случае, если даты выполнения работ (оказания услуг) и даты подписания (принятия)
                    работ (услуг) различны.</p>
                  <p>***Заполняется в случае наличия отчета о научных исследованиях, маркетинговых, консультационных и
                    прочих услугах.</p>
                </th>
                <th class="no-border-right"></th>
              </tr>
            </table>
          </div>
          <div v-show="(this.curr_module === 4 && this.new_act.inner_type !== 'Капстроительство' || this.curr_module === 3 && this.new_act.inner_type === 'Капстроительство') && this.new_act.type === 2" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <div style="width: 100% !important; display: flex; justify-content: flex-end; align-items: center; align-content: center">
                <span>Дата: </span><input class="input-act-params" type="date" placeholder="Дата" style="height: 1rem; width: 200px !important; margin-left: 1rem" v-model="new_act.dks_title_date">
              </div>
              <h4>Справка</h4>
              <h4>о стоимости выполненных строительных работ и затрат</h4>
              <h4>(ресурсный метод)</h4>
              <div style="display: flex; justify-content: center; gap: 2rem; align-items: center">
                <span>за</span>
                <input class="input-act-params" style="height: inherit" v-model="new_act.dks_month">
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <input class="input-act-params" style="height: inherit" placeholder="Введите наименование строительства" v-model="new_act.dks_cert_name">
              <input class="input-act-params" style="height: inherit" placeholder="Введите адрес строительства" v-model="new_act.object_address">
            </div>
            <table class="m-table-act" id="price52" style="">
              <tr>
                <th colspan="2">БИН/ИИН</th>
                <th colspan="2">КОПФ</th>
                <th colspan="2">Договор</th>
                <th colspan="4">Источник финансирования</th>
              </tr>
              <tr>
                <th>заказчика</th>
                <th>подрядчика</th>
                <th>заказчика</th>
                <th>подрядчика</th>
                <th>номер</th>
                <th>дата</th>
                <th colspan="3">Наименование программы/подпрограммы/специфики</th>
                <th>код</th>
              </tr>
              <tr>
                <td><input v-model="new_act.customer_bin" class="m-input-cell"/></td>
                <td><input v-model="new_act.impl_bin" class="m-input-cell"/></td>
                <td><input v-model="new_act.customer_org_form" class="m-input-cell"/></td>
                <td><input v-model="new_act.impl_org_form" class="m-input-cell"/></td>
                <td><input v-model="new_act.contract_number" class="m-input-cell"/></td>
                <td><input v-model="new_act.contract_date" class="m-input-cell"/></td>
                <td colspan="3"><input v-model="new_act.finance_source" class="m-input-cell"/></td>
                <td><input v-model="new_act.finance_code" class="m-input-cell"/></td>
              </tr>
              <tr>
                <th colspan="2" rowspan="3">Наименование пусковых комплексов, объектов</th>
                <th colspan="6">Стоимость выполненных работ и затрат в тенге</th>
                <th rowspan="3">НДС</th>
                <th rowspan="3">Всего к оплате</th>
              </tr>
              <tr>
                <th rowspan="2" style="overflow-wrap: break-word; word-break: break-word;">с начала<br> строительства по<br> отчетный месяц<br> включительно<br> с учетом НДС</th>
                <th rowspan="2" style="overflow-wrap: break-word; word-break: break-word;">с начала года по<br> отчетный месяц<br> включительно<br> с учетом НДС</th>
                <th rowspan="2">в отчетном месяце<br> без НДС</th>
                <th colspan="3">из них</th>
              </tr>
              <tr>
                <th style="overflow-wrap: break-word; word-break: break-word;">Строительно-<br>монтажные работы</th>
                <th style="overflow-wrap: break-word; word-break: break-word;">Оборудования,<br> мебели и инвентаря</th>
                <th>Прочих затрат</th>
              </tr>
              <tr>
                <td colspan="2">A</td>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in new_act.rows_certs" :key="index">
                <td colspan="2"><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.from_beg_construction" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.from_beg_year" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.constr_install" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.materials_purchase" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.other_expenses" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.nds" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_with_nds" v-on:change="auto_calc2()" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="10">
                  <button @click="add_row_cert" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_cert" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td colspan="2">Итого по справке</td>
                <td>{{ prettyPrice(new_act.total_from_beg_construction) }}</td>
                <td>{{ prettyPrice(new_act.total_from_beg_year) }}</td>
                <td>{{ prettyPrice(new_act.total_current_month) }}</td>
                <td v-for="i in [4,5,6]" :key="i"></td>
                <td>{{ prettyPrice(new_act.total_nds) }}</td>
                <td>{{ prettyPrice(new_act.total_twn) }}</td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 5 && this.new_act.type === 2 && this.new_act.inner_type === 'Текущий ремонт объeктов'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Расшифровка стоимости выполненных работ по объектам (к форме №3)</h4>
            </div>

            <table class="m-table-act" id="price52" style="">
              <tr>
                <th rowspan="3">№ п/п</th>
                <th rowspan="3">Наименование мероприятий</th>
                <th colspan="3">Утвержденный план на {{ this.new_act.act_date.year }} год</th>
                <th colspan="3">Фактическое выполнение за {{ this.new_act.act_month }} месяц {{ this.new_act.act_date.year }} год,<br> тыс.тенге без учета НДС</th>
                <th colspan="3">Фактическое выполнение с начала Договора на {{ this.new_act.act_date.year }} год,<br> тыс.тенге без учета НДС</th>
                <th colspan="3">ОСТАТОК от плана</th>
              </tr>
              <tr>
                <th rowspan="2">Кол-во</th>
                <th rowspan="2">Всего без оборудования, тыс. тенге, без НДС</th>
                <th>в том числе:</th>
                <th rowspan="2">Кол-во</th>
                <th rowspan="2">Всего стоимость работ, тыс. тенге</th>
                <th rowspan="2">Стоимость подрядных работ</th>
                <th rowspan="2">Кол-во</th>
                <th rowspan="2">Всего стоимость работ, тыс. тенге</th>
                <th rowspan="2">Стоимость подрядных работ</th>
                <th rowspan="2">Кол-во</th>
                <th rowspan="2">Всего стоимость работ, тыс. тенге</th>
                <th rowspan="2">Стоимость подрядных работ</th>
              </tr>
              <tr>
                <th>Стоимость подрядных работ</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10,11,12,13,14]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in new_act.rows_transc" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_count" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_impl_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month_count" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month_impl_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.beg_contract_count" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.beg_contract_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.beg_contract_impl_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_remainder_count" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_remainder_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_remainder_impl_total" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="14">
                  <button @click="add_row_transc" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_transc" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
            </table>
          </div>
          <!-- Расшифровка: Капстроительство (шаг 4) — без изменений -->
          <div v-show="this.new_act.type === 2 && this.curr_module === 4 && this.new_act.inner_type === 'Капстроительство'"
            class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Расшифровка</h4>
            </div>
            <div style="display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <span>по обьекту</span>
              <input class="input-act-params" style="height: inherit" placeholder="Введите наименование обьекта" v-model="new_act.dks_cert_name_2">
            </div>
            <table class="m-table-act" id="price52" style="">
              <tr>
                <th rowspan="2">№ п/п</th>
                <th rowspan="2">Наименование работ</th>
<!--                <th rowspan="2">ед.изм.</th>-->
                <th rowspan="2">Договорная стоимость</th>
                <th>Выполнение СМР за текущий месяц</th>
                <th>Выполнение СМР с начала года</th>
                <th>Выполнение СМР с начала строительства</th>
                <th rowspan="2">Остаток от договорной стомости</th>
              </tr>
              <tr>
                <th>тенге без НДС</th>
<!--                <th>Физ.объем СПТ, м</th>-->
<!--                <th>в том числе СМР по СПТ, тенге без НДС</th>-->
                <th>тенге без НДС</th>
<!--                <th>Физ.объем СПТ, м</th>-->
<!--                <th>в том числе СМР по СПТ, тенге без НДС</th>-->
                <th>тенге без НДС</th>
<!--                <th>Физ.объем СПТ, м</th>-->
<!--                <th>в том числе СМР по СПТ, тенге без НДС</th>-->
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in new_act.rows_transc" :key="index">
                <td>
                  {{ index + 1 }}
                </td>
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
<!--                <td><input type="number" v-model="row.measure_unit" class="m-input-cell"/></td>-->
                <td><input type="number" v-model="row.plan_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month_total" class="m-input-cell"/></td>
<!--                <td><input type="number" v-model="row.current_month_count" class="m-input-cell"/></td>-->
<!--                <td><input type="number" v-model="row.current_month_impl_total" class="m-input-cell"/></td>-->
                <td><input type="number" v-model="row.beg_contract_total" class="m-input-cell"/></td>
<!--                <td><input type="number" v-model="row.beg_contract_count" class="m-input-cell"/></td>-->
<!--                <td><input type="number" v-model="row.beg_contract_impl_total" class="m-input-cell"/></td>-->
                <td><input type="number" v-model="row.plan_remainder_total" class="m-input-cell"/></td>
<!--                <td><input type="number" v-model="row.plan_remainder_count" class="m-input-cell"/></td>-->
<!--                <td><input type="number" v-model="row.plan_remainder_impl_total" class="m-input-cell"/></td>-->
                <td><input type="number" v-model="row.plan_impl_total" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td></td>
                <td><b>Итоге по стройке</b></td>
                <td><input type="number" v-model="new_act.plan_total_rf" class="m-input-cell"/></td>
                <td><input type="number" v-model="new_act.current_month_total_rf" class="m-input-cell"/></td>
                <td><input type="number" v-model="new_act.beg_contract_total_rf" class="m-input-cell"/></td>
                <td><input type="number" v-model="new_act.plan_remainder_total_rf" class="m-input-cell"/></td>
                <td><input type="number" v-model="new_act.plan_impl_total_rf" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="7">
                  <button @click="add_row_transc" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_transc" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
            </table>
          </div>
          <!-- Расшифровка: Капремонт (шаг 5) — тенге/тыс. тенге по дате создания, Итого по стройке авто -->
          <div v-show="this.new_act.type === 2 && this.curr_module === 5 && this.new_act.inner_type === 'Капремонт'"
            class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Расшифровка</h4>
            </div>
            <div style="display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <span>по обьекту</span>
              <input class="input-act-params" style="height: inherit" placeholder="Введите наименование обьекта" v-model="new_act.dks_cert_name_2">
            </div>
            <table class="m-table-act" id="price52_kapr" style="">
              <tr>
                <th rowspan="2">№ п/п</th>
                <th rowspan="2">Наименование работ</th>
                <th rowspan="2">Договорная стоимость</th>
                <th>Выполнение СМР за текущий месяц</th>
                <th>Выполнение СМР с начала года</th>
                <th>Выполнение СМР с начала строительства</th>
                <th rowspan="2">Остаток от договорной стомости</th>
              </tr>
              <tr>
                <th>{{ usesThousandTengeLabel ? 'тыс. тенге без НДС' : 'тенге без НДС' }}</th>
                <th>{{ usesThousandTengeLabel ? 'тыс. тенге без НДС' : 'тенге без НДС' }}</th>
                <th>{{ usesThousandTengeLabel ? 'тыс. тенге без НДС' : 'тенге без НДС' }}</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in new_act.rows_transc" :key="index">
                <td>{{ index + 1 }}</td>
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.beg_contract_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_remainder_total" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.plan_impl_total" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td></td>
                <td><b>Итого по стройке</b></td>
                <td>{{ prettyPrice(new_act.rows_transc.reduce((s, r) => s + Number(r.plan_total || 0), 0)) }}</td>
                <td>{{ prettyPrice(new_act.rows_transc.reduce((s, r) => s + Number(r.current_month_total || 0), 0)) }}</td>
                <td>{{ prettyPrice(new_act.rows_transc.reduce((s, r) => s + Number(r.beg_contract_total || 0), 0)) }}</td>
                <td>{{ prettyPrice(new_act.rows_transc.reduce((s, r) => s + Number(r.plan_remainder_total || 0), 0)) }}</td>
                <td>{{ prettyPrice(new_act.rows_transc.reduce((s, r) => s + Number(r.plan_impl_total || 0), 0)) }}</td>
              </tr>
              <tr>
                <td colspan="7">
                  <button @click="add_row_transc" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_transc" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 3 && this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Бурение'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Акт приемки выполненных работ по строительству скважины</h4>
              <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; gap: 1rem;">
                <input class="input-act-params" style="height: inherit" v-model="new_act.dks_cert_name_2">
                <input class="input-act-params" style="height: inherit" v-model="new_act.dks_cert_name_3">
                <input class="input-act-params" style="height: inherit" v-model="new_act.dks_cert_name_4">
              </div>
            </div>
            <table class="m-table-act" id="price52" style="">
              <tr>
                <th>Наименование работ</th>
                <th>Ссылка</th>
                <th>Всего стоимость в тенге</th>
              </tr>
              <tr v-for="(row, index) in new_act.rows_accmini" :key="index">
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input v-model="row.link_text" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total" @change="auto_calc_mmg_accmini()" class="m-input-cell"/></td>
              </tr>
<!--              <tr>-->
<!--                <td></td>-->
<!--                <td>Всего:</td>-->
<!--                <td><input type="number" v-model="new_act.accmini_total" class="m-input-cell" /></td>-->
<!--              </tr>-->
              <tr>
                <td></td>
                <td>НДС:</td>
                <td><input type="number" v-model="new_act.accmini_nds" @change="auto_calc_mmg_accmini(true)" class="m-input-cell" /></td>
              </tr>
              <tr>
                <td></td>
                <td>Всего с учетом НДС:</td>
                <td><input type="number" v-model="new_act.accmini_total_with_nds" class="m-input-cell" /></td>
              </tr>
            </table>
          </div>
          <div v-show="this.curr_module === 4 && this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Бурение'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>Справка</h4>
              <h4>о стоимости выполненных работ и затрат</h4>
              <div style="display: flex; justify-content: center; gap: 2rem; align-items: center">
                <span>от</span>
                <input class="input-act-params" style="height: inherit" v-model="new_act.dks_month">
              </div>
            </div>
            <div style="display: flex; justify-content: space-between; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <input class="input-act-params" style="height: inherit" placeholder="Введите наименование строительства" v-model="new_act.dks_cert_name">
              <input class="input-act-params" style="height: inherit" placeholder="Введите адрес строительства" v-model="new_act.object_address">
            </div>
            <table class="m-table-act" id="price52" style="">
              <tr>
                <th>Код</th>
                <th>Код</th>
                <th colspan="2">Договор</th>
                <th colspan="3">Источник финансирования</th>
                <th colspan="4">Организационно-правовая норма</th>
              </tr>
              <tr>
                <th>заказчика</th>
                <th>подрядчика</th>
                <th>номер</th>
                <th>дата</th>
                <th colspan="2">наименование</th>
                <th>код</th>
                <th colspan="2">наименование</th>
                <th colspan="2">код</th>
              </tr>
              <tr>
                <td><input v-model="new_act.customer_bin" class="m-input-cell"/></td>
                <td><input v-model="new_act.impl_bin" class="m-input-cell"/></td>
                <td><input v-model="new_act.contract_number" class="m-input-cell"/></td>
                <td><input v-model="new_act.contract_date" class="m-input-cell"/></td>
                <td colspan="2"><input v-model="new_act.finance_source" class="m-input-cell"/></td>
                <td><input v-model="new_act.finance_code" class="m-input-cell"/></td>
                <td colspan="2"><input v-model="new_act.org_form_name" class="m-input-cell"/></td>
                <td colspan="2"><input v-model="new_act.org_form_code" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td>Код ТРУ</td>
                <td colspan="10"><input v-model="new_act.tru_code" class="m-input-cell" style="text-align: left !important;"/></td>
              </tr>
              <tr>
                <th rowspan="4">Наименование пусковых комплексов, объектов</th>
                <th colspan="8">Стоимость выполненных работ и затрат в тенге</th>
                <th rowspan="4">налог на добавленную стоимость</th>
                <th rowspan="4">Всего к оплате</th>
              </tr>
              <tr>
                <th rowspan="3" style="overflow-wrap: break-word; word-break: break-word;">с начала года по<br> отчетный месяц<br> включительно с НДС</th>
                <th rowspan="3">в отчетном месяце без НДС</th>
                <th colspan="6">из графы 1</th>
              </tr>
              <tr>
                <th rowspan="2" style="overflow-wrap: break-word; word-break: break-word;">Строительно-монтажные<br> работы в сметном базовом<br> уровне цен 2001г</th>
                <th colspan="2">из них</th>
                <th rowspan="2">стоимость прочих затрат, не входящих в состав СМР в сметном базовом уровне цен 2001 г.</th>
                <th colspan="2">дополнительные затраты</th>
              </tr>
              <tr>
                <th>в отчетном месяце</th>
                <th>по монтажу оборудования</th>
                <th>на приобретение материалов</th>
                <th>другие дополнительные расходы</th>
              </tr>
              <tr>
                <td>A</td>
                <td v-for="i in [1,2,3,4,5,6,7,8,9,10]" :key="i">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in new_act.rows_certs" :key="index">
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.from_beg_year" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.current_month" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.constr_install" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.constr_install_month" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.install_furniture" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.other_expenses" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.materials_purchase" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.additional_costs" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.nds" v-on:change="auto_calc2()" class="m-input-cell"/></td>
                <td><input type="number" v-model="row.total_with_nds" v-on:change="auto_calc2()" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="11">
                  <button @click="add_row_cert" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_cert" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
<!--              <tr>-->
<!--                <td>Итого по справке</td>-->
<!--                <td>{{ prettyPrice(new_act.total_from_beg_year) }}</td>-->
<!--                <td>{{ prettyPrice(new_act.total_current_month) }}</td>-->
<!--                <td v-for="i in [3,4,5,6,7,8]" :key="i"></td>-->
<!--                <td>{{ prettyPrice(new_act.total_nds) }}</td>-->
<!--                <td>{{ prettyPrice(new_act.total_twn) }}</td>-->
<!--              </tr>-->
            </table>
          </div>
          <div v-show="this.curr_module === 4 && this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'КРС'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>АКТ</h4>
              <h4>приемки законченных капитальным ремонтом скважин</h4>
              <h4>по состоянию за {{ new_act.act_month }} месяц г.</h4>
            </div>
            <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <span style="width: 20%">Cтоимость 1 бригада/часа</span>
              <input class="input-act-params" type="number" style="height: inherit" placeholder="Введите стоимость 1 бригада/часа (тенге)" v-model="new_act.dbikrs_unit_price" @change="auto_calc_krs_all()">
            </div>
            <table :key="'krs-' + krsTableKey" class="m-table-act" id="price52" style="">
              <tr>
                <th>№ п/п</th>
                <th>Цех №</th>
                <th>№ скв.</th>
                <th>Шифр и вид ремонта</th>
                <th>Начало ремонта</th>
                <th>Конец ремонта</th>
                <th>Фактическое время, бр/час</th>
                <th>УНВ, бр/час</th>
                <th>Оплаченное время, бр/час</th>
                <th>Сумма, тенге</th>
                <th style="border: none !important;"></th>
              </tr>
              <template v-for="(row, index) in new_act.rows_accmax">
                <tr v-if="row.parent_sort_number === 0">
                  <td :rowspan="new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2" style="padding:0;"><input v-model="row.display_number" class="m-input-cell" style="text-align:center;"/></td>
                  <td :rowspan="new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2"><input v-model="row.shop_number" class="m-input-cell" :style="'height: ' + 35*(new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2) + 'px !important'"/></td>
                  <td :rowspan="new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2"><input v-model="row.well_number" class="m-input-cell" :style="'height: ' + 35*(new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2) + 'px !important'"/></td>
                  <td><input v-model="row.work_name" class="m-input-cell"/></td>
                  <td :rowspan="new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2"><input v-model="row.started_date" type="date" class="m-input-cell" :style="'height: ' + 35*(new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2) + 'px !important'"/></td>
                  <td :rowspan="new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2"><input v-model="row.ended_date" type="date" class="m-input-cell" :style="'height: ' + 35*(new_act.rows_accmax.filter(i => i.parent_sort_number === row.sort_number).length + 2) + 'px !important'"/></td>
                  <td><input v-model.number="row.fact_time" type="number" class="m-input-cell"/></td>
                  <td><input v-model.number="row.unv_time" type="number" class="m-input-cell"/></td>
                  <td><input v-model.number="row.payed_time" type="number" @change="auto_calc_krs_total(index)" class="m-input-cell"/></td>
                  <td><input v-model.number="row.total" @change="auto_calc3()" type="number" class="m-input-cell"/></td>
                  <td style="border: none !important;"></td>
                </tr>
                <tr v-else>
                  <td><input v-model="row.work_name" class="m-input-cell"/></td>
                  <td><input v-model.number="row.fact_time" type="number" class="m-input-cell"/></td>
                  <td><input v-model.number="row.unv_time" type="number" class="m-input-cell"/></td>
                  <td><input v-model.number="row.payed_time" type="number" @change="auto_calc_krs_total(index)" class="m-input-cell"/></td>
                  <td><input v-model.number="row.total" @change="auto_calc3()" type="number" class="m-input-cell"/></td>
                  <td style="border: none !important;"></td>
                </tr>
                <template v-if="new_act.rows_accmax.length === index + 1 || new_act.rows_accmax[index + 1].parent_sort_number === 0">
                  <tr>
                    <td style="height: 35px !important;">
                      ВСЕГО:
                    </td>
                    <td>{{ prettyPrice(Number(new_act.rows_accmax.filter(item => item.sort_number === row.sort_number).reduce((acc, i) => acc + Number(i.fact_time || 0), 0).toFixed(2))) }}</td>
                    <td>{{ prettyPrice(Number(new_act.rows_accmax.filter(item => item.sort_number === row.sort_number).reduce((acc, i) => acc + Number(i.unv_time || 0), 0).toFixed(2))) }}</td>
                    <td>{{ prettyPrice(Number(new_act.rows_accmax.filter(item => item.sort_number === row.sort_number).reduce((acc, i) => acc + Number(i.payed_time || 0), 0).toFixed(2))) }}</td>
                    <td>{{ prettyPrice(Number(new_act.rows_accmax.filter(item => item.sort_number === row.sort_number).reduce((acc, i) => acc + Number(i.total || 0), 0).toFixed(2))) }}</td>
                    <td style="border: none !important;">
                      <span style="padding: 6px; border-radius: 5px; background: #0c8; color: white; cursor: pointer" @click="add_row_accmax_inner(index)">Добавить сроку выше</span>
                    </td>
                  </tr>
                </template>
              </template>

              <tr>
                <td colspan="11">
                  <button @click="add_row_accmax" type="button" class="add_row_btn" title="Добавить строку (в конец)">
                    +
                  </button>
                  <button @click="rm_row_accmax" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">Всего по акту:</td>
                <td>{{ prettyPrice(Number(new_act.rows_accmax.reduce((acc, i) => acc + Number(i.fact_time || 0), 0).toFixed(2))) }}</td>
                <td>{{ prettyPrice(Number(new_act.rows_accmax.reduce((acc, i) => acc + Number(i.unv_time || 0), 0).toFixed(2))) }}</td>
                <td>{{ prettyPrice(Number(new_act.rows_accmax.reduce((acc, i) => acc + Number(i.payed_time || 0), 0).toFixed(2))) }}</td>
                <td>{{ prettyPrice(new_act.accmax_total) }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td colspan="7" style="text-align: left !important; padding-left: 20px !important;">НДС:</td>
                <td>{{ prettyPrice(new_act.accmax_nds) }}</td>
              </tr>
              <tr>
                <td></td>
                <td></td>
                <td colspan="7" style="text-align: left !important; padding-left: 20px !important;">Всего с НДС:</td>
                <td>{{ prettyPrice(new_act.accmax_total_with_nds) }}</td>
              </tr>
            </table>
          </div>

          <div v-show="this.curr_module === 4 && this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Супервайзер'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: space-between; width: 100%;">
              <span>ЗАКАЗЧИК:<br>{{ new_act.ngdu }}</span>
              <span style="text-align: right">ПОДРЯДЧИК</span>
            </div>
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>АКТ</h4>
              <h4 style="display: flex; align-items: center; gap: .5rem; flex-wrap: wrap; justify-content: center">
                сдачи-приемки оказанных услуг на месторождениях
                <input class="input-act-params" style="width: 320px; height: 2rem" placeholder="Укажите месторождения*" v-model="new_act.supervisor_location">
              </h4>
              <h4>за {{ new_act.act_month }} месяц {{ new_act.act_date ? new_act.act_date.split('-')[0] : '' }} г.</h4>
            </div>
            <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <span style="width: 20%">Тариф, тенге/час</span>
              <input class="input-act-params" type="number" style="height: inherit" placeholder="Введите тариф (тенге/час)*" v-model.number="new_act.dbikrs_unit_price" @change="auto_calc_supervisor()">
            </div>
            <table class="m-table-act">
              <tr>
                <th>№ п/п</th>
                <th>Наименование видов работ</th>
                <th>№ скв.</th>
                <th>Кол-во супервайзеров</th>
                <th>Отработанный период</th>
                <th>Кол-во дней</th>
                <th>Отработанное время, часов</th>
                <th>Стоимость услуг, тенге</th>
              </tr>
              <tr>
                <td v-for="i in [1,2,3,4,5,6,7,8]" :key="i" style="text-align:center; font-size: 10px">{{ i }}</td>
              </tr>
              <tr v-for="(row, index) in new_act.rows_supervisor" :key="'sv-' + index">
                <td>{{ index + 1 }}</td>
                <td><input v-model="row.work_name" class="m-input-cell"/></td>
                <td><input v-model="row.well_number" class="m-input-cell"/></td>
                <td><input v-model.number="row.supervisor_count" type="number" class="m-input-cell"/></td>
                <td><input v-model="row.worked_period" class="m-input-cell"/></td>
                <td><input v-model.number="row.days_count" type="number" class="m-input-cell"/></td>
                <td><input v-model.number="row.hours" type="number" @change="auto_calc_supervisor()" class="m-input-cell"/></td>
                <td>{{ prettyPrice(row.cost) }}</td>
              </tr>
              <tr>
                <td colspan="8">
                  <button @click="add_row_supervisor" type="button" class="add_row_btn" title="Добавить строку (в конец)">+</button>
                  <button @click="rm_row_supervisor" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td colspan="5" style="text-align: left !important; padding-left: 20px !important;">Всего:</td>
                <td>{{ prettyPrice(new_act.rows_supervisor.reduce((acc, i) => acc + Number(i.days_count || 0), 0)) }}</td>
                <td>{{ prettyPrice(new_act.rows_supervisor.reduce((acc, i) => acc + Number(i.hours || 0), 0)) }}</td>
                <td>{{ prettyPrice(new_act.total) }}</td>
              </tr>
              <tr>
                <td colspan="7" style="text-align: left !important; padding-left: 20px !important;">Сумма НДС:</td>
                <td>{{ prettyPrice(new_act.nds) }}</td>
              </tr>
              <tr>
                <td colspan="7" style="text-align: left !important; padding-left: 20px !important;">Сумма с НДС:</td>
                <td>{{ prettyPrice(new_act.total_with_nds) }}</td>
              </tr>
            </table>
          </div>

          <div v-show="this.curr_module === 4 && this.new_act.type === 4 && this.new_act.ptopd_inner_type === 'ПРС'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>АКТ</h4>
              <h4>приемки законченных подземным ремонтом скважин</h4>
              <h4>за {{ new_act.act_month }} {{ new_act.act_date ? new_act.act_date.split('-')[0] : '' }} г.</h4>
            </div>
            <div style="display: flex; justify-content: flex-end; gap: 1rem; margin-top: .5rem; height: 1rem !important;">
              <span style="width: 25%">Стоимость 1 бригадо-часа, тенге</span>
              <input class="input-act-params" type="number" style="height: inherit" placeholder="Введите стоимость 1 бригадо-часа" v-model.number="new_act.ptopd_unit_price" @change="auto_calc_prs()">
            </div>
            <table class="m-table-act">
              <tr>
                <th>№ п/п</th>
                <th>№ бр</th>
                <th>№ скв.</th>
                <th>С/э</th>
                <th>Цех</th>
                <th>Вид ремонта</th>
                <th>Начало ремонта</th>
                <th>Конец ремонта</th>
                <th>Фактическое время</th>
                <th>Оплаченное время</th>
                <th>Не оплаченное время</th>
                <th>Сумма, тенге</th>
              </tr>
              <tr v-for="(row, index) in new_act.rows_prs" :key="index">
                <td>{{ index + 1 }}</td>
                <td><input v-model="row.brigade_number" class="m-input-cell"/></td>
                <td><input v-model="row.well_number" class="m-input-cell"/></td>
                <td><input v-model="row.se" class="m-input-cell"/></td>
                <td><input v-model="row.shop" class="m-input-cell"/></td>
                <td><input v-model="row.repair_type" class="m-input-cell"/></td>
                <td><input v-model="row.started_date" type="date" class="m-input-cell"/></td>
                <td><input v-model="row.ended_date" type="date" class="m-input-cell"/></td>
                <td><input v-model.number="row.fact_time" type="number" class="m-input-cell"/></td>
                <td><input v-model.number="row.payed_time" type="number" @change="auto_calc_prs()" class="m-input-cell"/></td>
                <td><input v-model.number="row.unpaid_time" type="number" class="m-input-cell"/></td>
                <td>{{ prettyPrice(row.cost) }}</td>
              </tr>
              <tr>
                <td colspan="12">
                  <button @click="add_row_prs" type="button" class="add_row_btn" title="Добавить строку (в конец)">+</button>
                  <button @click="rm_row_prs" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td colspan="11" style="text-align: left !important; padding-left: 20px !important;">Итого:</td>
                <td>{{ prettyPrice(new_act.total) }}</td>
              </tr>
              <tr>
                <td colspan="11" style="text-align: left !important; padding-left: 20px !important;">НДС:</td>
                <td>{{ prettyPrice(new_act.nds) }}</td>
              </tr>
              <tr>
                <td colspan="11" style="text-align: left !important; padding-left: 20px !important;">Всего с НДС:</td>
                <td>{{ prettyPrice(new_act.total_with_nds) }}</td>
              </tr>
            </table>
          </div>

          <div v-show="this.curr_module === 4 && this.new_act.type === 4 && this.new_act.ptopd_inner_type === 'Перевозка насосов'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>АКТ</h4>
              <h4>выполненных работ по завозу и вывозу насосов</h4>
              <h4>за {{ new_act.act_month }} {{ new_act.act_date ? new_act.act_date.split('-')[0] : '' }} г.</h4>
            </div>
            <table class="m-table-act">
              <tr>
                <th rowspan="2">№ п/п</th>
                <th rowspan="2">Наименование площади, месторождение</th>
                <th colspan="3">За отчетный период</th>
                <th colspan="3">С начала года</th>
              </tr>
              <tr>
                <th>Кол-во рейсов</th>
                <th>Кол-во насосов</th>
                <th>Сумма, тенге</th>
                <th>Кол-во рейсов</th>
                <th>Кол-во насосов</th>
                <th>Сумма, тенге</th>
              </tr>
              <tr v-for="(row, index) in new_act.rows_pump" :key="index">
                <td>{{ index + 1 }}</td>
                <td><input v-model="row.field_name" class="m-input-cell"/></td>
                <td><input v-model.number="row.trips_period" type="number" class="m-input-cell"/></td>
                <td><input v-model.number="row.pumps_period" type="number" class="m-input-cell"/></td>
                <td><input v-model.number="row.sum_period" type="number" @change="auto_calc_pump()" class="m-input-cell"/></td>
                <td><input v-model.number="row.trips_year" type="number" class="m-input-cell"/></td>
                <td><input v-model.number="row.pumps_year" type="number" class="m-input-cell"/></td>
                <td><input v-model.number="row.sum_year" type="number" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="8">
                  <button @click="add_row_pump" type="button" class="add_row_btn" title="Добавить строку (в конец)">+</button>
                  <button @click="rm_row_pump" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">Итого по акту:</td>
                <td>{{ prettyPrice(new_act.total) }}</td>
                <td colspan="3"></td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">НДС:</td>
                <td>{{ prettyPrice(new_act.nds) }}</td>
                <td colspan="3"></td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">Всего с НДС:</td>
                <td>{{ prettyPrice(new_act.total_with_nds) }}</td>
                <td colspan="3"></td>
              </tr>
            </table>
          </div>

          <div v-show="this.curr_module === 4 && this.new_act.type === 4 && this.new_act.ptopd_inner_type === 'Химизация'" class="flex-start-column gap-2r">
            <div style="display: flex; justify-content: center; align-items: center; flex-direction: column">
              <h4>АКТ</h4>
              <h4>выполненных работ по химизации</h4>
              <h4>за {{ new_act.act_month }} {{ new_act.act_date ? new_act.act_date.split('-')[0] : '' }} г.</h4>
            </div>
            <table class="m-table-act">
              <tr>
                <th>№ п/п</th>
                <th>№ акта</th>
                <th>№ цеха</th>
                <th>Месторождение / площадь</th>
                <th>Сумма, тенге</th>
              </tr>
              <tr v-for="(row, index) in new_act.rows_chem" :key="index">
                <td>{{ index + 1 }}</td>
                <td><input v-model="row.act_number" class="m-input-cell"/></td>
                <td><input v-model="row.shop" class="m-input-cell"/></td>
                <td><input v-model="row.area" class="m-input-cell"/></td>
                <td><input v-model.number="row.amount" type="number" @change="auto_calc_chem()" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="5">
                  <button @click="add_row_chem" type="button" class="add_row_btn" title="Добавить строку (в конец)">+</button>
                  <button @click="rm_row_chem" type="button" class="rm_row_btn" title="Убрать строку (с конца)">-</button>
                </td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">ИТОГО:</td>
                <td><input v-model.number="new_act.total" type="number" @change="chem_totals_from_total()" class="m-input-cell"/></td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">НДС:</td>
                <td>{{ prettyPrice(new_act.nds) }}</td>
              </tr>
              <tr>
                <td colspan="4" style="text-align: left !important; padding-left: 20px !important;">Всего с НДС:</td>
                <td><input v-model.number="new_act.total_with_nds" type="number" class="m-input-cell"/></td>
              </tr>
            </table>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import actVat from "../mixins/actVat";
import router from "../router.js";

export default {
  mixins: [actVat],
  name: 'CreateActSteps',
  data() {
    return {
      // downloadTemplate: `${process.env.VUE_APP_MEDIA_URL}/media/template_AVR.pdf`,
      curr_module: 1,
      all_steps: [
        {
          name: 'Параметры',
          instruction: 'На данном шаге введите основные параметры акта, формы в дальнейших шагах будут построены в зависимости от выбранных Вами параметров',
        },
        {
          name: 'Приложения',
          instruction: 'На данном шаге прикрепите все дополнительные файлы (документы / фотографии), необходимые для успешного согласования акта выполненных работ и услуг',
        },
        {
          name: 'Таблица',
          instruction: 'На данном шаге введите основные табличные данные по акту выполненных работ и услуг, учтите, что некоторые поля расчитываются автоматически',
        },
        {
          name: 'Справка',
          instruction: 'На данном шаге введите данные по справке о стоимости выполненных работ и затрат актов ДКС',
        },
        {
          name: 'Расшифровка',
          instruction: 'На данном шаге введите данные по расшифровке стоимости выполненных работ и затрат  по ДКС',
        },
      ],
      ngdu_list: [
        'АО "Мангистаумунайгаз"',
        'ПУ "Каламкасмунайгаз"',
        'ПУ "Жетыбаймунайгаз"'
      ],
      months_list: [
         "Январь",
         "Февраль",
         "Март",
         "Апрель",
         "Май",
         "Июнь",
         "Июль",
         "Август",
         "Сентябрь",
         "Октябрь",
         "Ноябрь",
         "Декабрь"
      ],
      contracts: [],
      cost_list: [],
      mvz_list: [],
      row_date_type: '1',
      row_type: '',
      inner_type_list: [
        "Капремонт",
        "Текущий ремонт объeктов",
        "Капстроительство"
      ],
      dbikrs_inner_type_list: [
        "Бурение",
        "КРС",
        "Супервайзер"
      ],
      ptopd_inner_type_list: [
        "ПРС",
        "Перевозка насосов",
        "Химизация"
      ],
      row_date_type_template: '',
      template_row_count: '',
      template_header_count: 1,
      krsTableKey: 0,
      row_accept_type: '',
      row_accept_count: 1,
      curr_serial: 1,
      months: [
        { value: 1, label: 'Январь' },
        { value: 2, label: 'Февраль' },
        { value: 3, label: 'Март' },
        { value: 4, label: 'Апрель' },
        { value: 5, label: 'Май' },
        { value: 6, label: 'Июнь' },
        { value: 7, label: 'Июль' },
        { value: 8, label: 'Август' },
        { value: 9, label: 'Сентябрь' },
        { value: 10, label: 'Октябрь' },
        { value: 11, label: 'Ноябрь' },
        { value: 12, label: 'Декабрь' },
      ],
      new_act: {
        plan_total_rf: 0.0,
        current_month_total_rf: 0.0,
        beg_contract_total_rf: 0.0,
        plan_remainder_total_rf: 0.0,
        plan_impl_total_rf: 0.0,
        dks_month: null, // 1..12
        dks_year: 2026,
        uploading: false,
        object_name_short: '',
        object_address: '',
        object_address_2: '',
        inner_type: 'Капремонт',
        dbikrs_inner_type: 'КРС',
        dks_name: '',
        dks_cert_name: '',
        dks_cert_name_2: '',
        dks_cert_name_3: '',
        dks_cert_name_4: '',
        price_comment: '',
        tru_code: '',
        customer_bin: '990140000483',
        customer_org_form: '28',
        customer_account_number: '',
        impl_bin: '',
        impl_org_form: '20',
        contract_number: '',
        contract_date: '',
        finance_source: '',
        finance_code: '',
        org_form_name: '',
        org_form_code: '',

        dbikrs_unit_price: 0.0,
        total_from_beg_year: 0.0,
        total_from_beg_construction: 0.0,
        total_contract_total: 0.0,
        total_current_month: 0.0,
        total_nds: 0.0,
        total_twn: 0.0,
        nds_from_beg_construction: 0.0,
        nds_contract_total: 0.0,
        nds_current_month: 0.0,
        twn_from_beg_construction: 0.0,
        twn_contract_total: 0.0,
        twn_current_month: 0.0,
        accmini_total: 0.0,
        accmini_nds: 0.0,
        accmini_total_with_nds: 0.0,

        accmax_total: 0.0,
        accmax_nds: 0.0,
        accmax_total_with_nds: 0.0,

        type: 1,
        number: '',
        act_date: '',
        name: '',
        contract: {
          id: '',
        },
        ngdu: 'АО "Мангистаумунайгаз"',
        double_files: [],
        object_name: '',
        act_month: '',
        global_mvz: '',
        global_work: '',
        total: 0.0,
        nds: 0.0,
        total_with_nds: 0.0,
        total_count: 0,
        rows: [],
        rows_accept: [],
        rows_certs: [],
        rows_transc: [],
        rows_accmini: [{ work_name: '', link_text: '', total: 0.0 }],
        rows_accmax: [],
        rows_supervisor: [],
        supervisor_location: '',
        ptopd_inner_type: 'ПРС',
        ptopd_unit_price: 0.0,
        rows_prs: [],
        rows_pump: [],
        rows_chem: []
      }
    };
  },
  mounted() {
  },
  watch: {
    curr_module(val) {
      // ДБиКРС-Бурение: при входе на шаг «Справка» стоимость с Акта приемки
      // автоматически садится в графу «в отчетном месяце без НДС» и НДС
      // пересчитывается без ручного ввода цифры (задача #89)
      if (val === 4 && this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Бурение') {
        this.auto_calc_mmg_accmini(true);
      }
    },
  },
  computed: {
    // ДКС-Капремонт (шаг 5): акты, создаваемые по 04.06.2026 включительно,
    // показывают суммы расшифровки в «тыс. тенге без НДС» (старый формат).
    usesThousandTengeLabel() {
      const cutoff = new Date(2026, 5, 4) // месяцы с 0 → июнь = 5
      const today = new Date()
      today.setHours(0, 0, 0, 0)
      return today <= cutoff
    },
    totalPlanSum() {
      if (!this.new_act || !this.new_act.rows_transc) return 0

      return this.new_act.rows_transc.reduce((sum, row) => {
        return sum + Number(row.plan_total || 0)
      }, 0)
    },
    currentMonthTotalSum() {
      if (!this.new_act || !this.new_act.rows_transc) return 0

      return this.new_act.rows_transc.reduce((sum, row) => {
        return sum + Number(row.current_month_total || 0)
      }, 0)
    },
    begContractTotalSum() {
      if (!this.new_act || !this.new_act.rows_transc) return 0

      return this.new_act.rows_transc.reduce((sum, row) => {
        return sum + Number(row.beg_contract_total || 0)
      }, 0)
    },
    planRemainderTotalSum() {
      if (!this.new_act || !this.new_act.rows_transc) return 0

      return this.new_act.rows_transc.reduce((sum, row) => {
        return sum + Number(row.plan_remainder_total || 0)
      }, 0)
    },
    planImplTotalSum() {
      if (!this.new_act || !this.new_act.rows_transc) return 0

      return this.new_act.rows_transc.reduce((sum, row) => {
        return sum + Number(row.plan_impl_total || 0)
      }, 0)
    },
    years() {
      const now = new Date().getFullYear()
      const from = now - 5
      const to = now + 1
      const arr = []
      for (let y = to; y >= from; y--) arr.push(y)
      return arr
    },
    all_required_exist: function () {
      if (this.curr_module === 1 && this.new_act.type !== 2) {
        if (this.new_act.number !== '' &&
            this.new_act.name !== '' &&
            this.new_act.ngdu !== '' &&
            this.new_act.act_date !== '' &&
            this.new_act.contract.id !== '') {
          return true;
        } else {
          return false;
        }
      } else if (this.curr_module === 1) {
        if (this.new_act.number !== '' &&
            this.new_act.name !== '' &&
            this.new_act.act_date !== '' &&
            this.new_act.contract.id !== '' &&
            this.new_act.ngdu !== '' &&
            this.new_act.inner_type !== '' &&
            this.new_act.act_month !== '') {
          return true;
        } else {
          return false;
        }
      } else if (this.curr_module === 3) {
        if (this.new_act.type === 2 && this.new_act.inner_type === 'Капстроительство') {
          return true;
        }

        if (this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Бурение') {
          return true;
        }

        if (this.new_act.rows.length < 1) {
          return false;
        } else {
          // if (this.new_act.type === 1) {
          return true;
          // }
          for (let i = 0; i < this.new_act.rows.length; i++) {
            let row = this.new_act.rows[i];
            if (this.new_act.type !== 2) {
              if (row.work_name === '' ||
                  row.mvz_name === '' ||
                  row.measure_unit === '' ||
                  row.double_date && row.start_date === '' ||
                  row.double_date && row.end_date === '' ||
                  !row.double_date && row.row_date === '') {
                return false;
              }
            } else {
              if (row.work_name === '' ||
                  row.mvz_name === '' ||
                  row.measure_unit === '') {
                return false;
              }
            }
          }
        }
      } else if (this.curr_module === 4) {
        // Супервайзер: сабмит на шаге 4 — нужен тариф и хотя бы одна строка акта
        if (this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Супервайзер') {
          return this.new_act.rows_supervisor.length > 0 && Number(this.new_act.dbikrs_unit_price) > 0 &&
              (this.new_act.supervisor_location || '').trim() !== '';
        }
        // ПТО ПД: сабмит на шаге 4 — валидируем форму подтипа
        if (this.new_act.type === 4) {
          if (this.new_act.ptopd_inner_type === 'Перевозка насосов') {
            return this.new_act.rows_pump.length > 0;
          } else if (this.new_act.ptopd_inner_type === 'Химизация') {
            return this.new_act.rows_chem.length > 0;
          }
          return this.new_act.rows_prs.length > 0 && Number(this.new_act.ptopd_unit_price) > 0;
        }
      }
      return true;
    },
  },
  created() {
    this.new_act.type = parseInt(this.$route.params.id);
    if (this.new_act.type !== 2) {
      this.all_steps.pop();
      this.all_steps.pop();
    }

    if (this.new_act.type === 3) {
      this.all_steps.push({
        name: "Акт приемки",
        instruction: "На данном шаге введите данные по акту приемки выполненных работ по строительству скважин/законченных капитальным ремонтом скважин"
      })
      this.all_steps.push({
        name: "Справка",
        instruction: "На данном шаге введите данные по справке о стоимости выполненных работ и затрат актов Бурения"
      })
    }

    if (this.new_act.type === 4) {
      this.change_ptopd_type();
    }

    this.getMyContracts();
    this.getCostList();
    this.getMVZList();
  },
  methods: {
    change_steps() {
      // console.log('asdsasd')
      if (this.new_act.inner_type === 'Капстроительство') {
      // alert('qwe')
        this.all_steps.splice(2, 1);
      } else if (this.all_steps.length === 4) {
        this.all_steps.splice(2, 0, {
          name: 'Таблица',
          instruction: 'На данном шаге введите основные табличные данные по акту выполненных работ и услуг, учтите, что некоторые поля расчитываются автоматически',
        });
      }
    },
    change_contract() {
      let aa = this.contracts.filter(i => i.id === this.new_act.contract.id);
      if (aa.length > 0) {
        this.new_act.contract_number = aa[0].number;
        this.new_act.contract_date = aa[0].date_from;
        this.new_act.impl_bin = aa[0].impl_company.bin;
      }
    },
    change_steps_dbikrs() {
      // Пересобираем шаги детерминированно под подтип (задача #47):
      // КРС — 5 шагов, Бурение — 4, Супервайзер — 3 (форма акта прямо на шаге 3).
      const params = this.all_steps[0];
      const attach = this.all_steps[1];
      const tabl = {
        name: 'Таблица',
        instruction: 'На данном шаге введите основные табличные данные по акту выполненных работ и услуг, учтите, что некоторые поля расчитываются автоматически',
      };
      const priem = {
        name: 'Акт приемки',
        instruction: 'На данном шаге введите данные по акту приемки выполненных работ по строительству скважин/законченных капитальным ремонтом скважин',
      };
      const sprav = {
        name: 'Справка',
        instruction: 'На данном шаге введите данные по справке о стоимости выполненных работ и затрат актов Бурения',
      };
      if (this.new_act.dbikrs_inner_type === 'Бурение') {
        this.all_steps = [params, attach, priem, sprav];
      } else if (this.new_act.dbikrs_inner_type === 'Супервайзер') {
        // Супервайзер: шаг 3 — Форма Р-1 (таблица работ), шаг 4 — Акт сдачи-приемки
        this.all_steps = [params, attach, {
          name: 'Форма Р-1',
          instruction: 'На данном шаге заполните строки формы Р-1 (акта выполненных работ): наименование услуг супервайзерского сопровождения, количество, цена и стоимость',
        }, {
          name: 'Акт сдачи-приемки',
          instruction: 'На данном шаге укажите тариф (тенге/час) и заполните строки акта сдачи-приемки оказанных услуг супервайзера, стоимость рассчитывается автоматически',
        }];
        if (this.new_act.rows_supervisor.length === 0) {
          this.add_row_supervisor();
        }
      } else {
        this.all_steps = [params, attach, tabl, priem, sprav];
      }
    },
    toFixedTruncFloat2(figure) {
      return parseFloat((parseInt(figure * 1000 / 10) / 100.0).toFixed(2));
    },
    toFixedFloat2(figure) {
      return parseFloat(parseFloat(figure).toFixed(2));
    },
    toFixedFloat3(figure) {
      return parseFloat(parseFloat(figure).toFixed(3));
    },
    isPartitive2(value) {
      let partitive_value = value.toString().replace(',', '.').split('.');
      if (partitive_value.length > 1) {
        if (partitive_value[1].length > 2) {
          return true;
        }
      }
      return false;
    },
    auto_calc(only_nds=false) {
      if (!this.vatReady) return;
      let total = 0.0;
      let rounding_flag = false;
      let negative_flag = false;
      for (let i = 0; i < this.new_act.rows.length; i++) {
        let row = this.new_act.rows[i];
        if (row.count === '') {
          row.count = 0.0;
        }
        if (row.unit_price === '') {
          row.unit_price = 0.0;
        }
        if (row.reason_cost === '') {
          row.reason_cost = 0.0;
        }

        row.count = parseFloat(row.count);
        rounding_flag = rounding_flag || this.isPartitive2(row.unit_price);
        row.unit_price = this.toFixedFloat2(row.unit_price);

        rounding_flag = rounding_flag || this.isPartitive2(row.reason_cost);
        row.reason_cost = this.toFixedFloat2(row.reason_cost);

        if (row.unit_price < 0) {
          row.unit_price = 0.0;
          negative_flag = true;
        }
        if (row.count < 0) {
          row.count = 0.0;
          negative_flag = true;
        }
        if (row.reason_cost < 0 || row.unit_price * row.count - row.reason_cost < 0) {
          row.reason_cost = 0.0;
          negative_flag = true;
        }

        // rounding_flag = rounding_flag || this.isPartitive2(row.count * row.unit_price);
        row.total = this.toFixedFloat2(row.count * row.unit_price - row.reason_cost);

        total += row.total;
      }

      if (this.new_act.nds === '') {
        this.new_act.nds = 0.0;
      }

      if (!only_nds) {
        this.new_act.nds = total * this.profile_nds_rate();
      }

      rounding_flag = rounding_flag || this.isPartitive2(this.new_act.nds);
      this.new_act.nds = this.toFixedFloat2(this.new_act.nds);
      if (this.new_act.nds < 0) {
        this.new_act.nds = 0.0;
        negative_flag = true;
      }

      this.new_act.total = total;
      this.new_act.total_with_nds = this.new_act.total + this.new_act.nds;

      if (rounding_flag && negative_flag) {
        // alert('1. Значения в числовых ячейках не могут быть < 0; 2. Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Значения не могут быть меньше нуля. Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (rounding_flag) {
        // alert('Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (negative_flag) {
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Значения в числовых ячейках не могут быть отрицательными значениями',
          })
      }
    },
    auto_calc_mmg_accmini(preserve_nds = false) {
      if (!this.vatReady) return;
      let total_acc = 0.0;

      for (let i = 0; i < this.new_act.rows_accmini.length; i++) {
        let row = this.new_act.rows_accmini[i];
        total_acc += Number(row.total || 0);
      }
      // console.log('total_acc');
      // console.log(total_acc);
      this.new_act.accmini_total = this.toFixedFloat2(total_acc);
      const entered_nds = Number(this.new_act.accmini_nds);
      this.new_act.accmini_nds = preserve_nds && Number.isFinite(entered_nds)
        ? this.toFixedFloat2(Math.max(0, entered_nds))
        : this.toFixedFloat2(this.new_act.accmini_total * this.profile_nds_rate());
      this.new_act.accmini_total_with_nds = this.toFixedFloat2(this.new_act.accmini_total + this.new_act.accmini_nds);
      if (this.new_act.rows_certs.length > 0) {
        this.new_act.rows_certs[0].current_month = this.new_act.accmini_total;
        // Пересчитываем справку сразу после заполнения current_month, чтобы НДС
        // отображался без ручного ввода цифры в поле (задача #89).
        this.auto_calc2();
      }
    },
    auto_calc_mmg_global() {
      if (!this.vatReady) return;
      let total = 0.0;
      let nds = 0.0;
      let total_with_nds = 0.0;
      let line_total = 0.0;
      let line_nds = 0.0;
      let line_twn = 0.0;
      let has_line_rows = false;

      for (let i = 0; i < this.new_act.rows.length; i++) {
        let row = this.new_act.rows[i];
        if (row.count === '' || row.count < 0) {
          this.new_act.rows[i].count = 0.0;
        }
        if (row.unit_price === '' || row.unit_price < 0) {
          this.new_act.rows[i].unit_price = 0.0;
        }
        if (row.total === '' || row.total < 0) {
          this.new_act.rows[i].total = 0.0;
        }
        if (row.nds === '' || row.nds < 0) {
          this.new_act.rows[i].nds = 0.0;
        }
        if (row.total_with_nds === '' || row.total_with_nds < 0) {
          this.new_act.rows[i].total_with_nds = 0.0;
        }

        this.new_act.rows[i].count = this.toFixedFloat3(this.new_act.rows[i].count)
        this.new_act.rows[i].unit_price = this.toFixedFloat2(this.new_act.rows[i].unit_price);
        this.new_act.rows[i].total = this.toFixedFloat2(this.new_act.rows[i].total);
        this.new_act.rows[i].nds = this.toFixedFloat2(this.new_act.rows[i].nds);
        this.new_act.rows[i].total_with_nds = this.toFixedFloat2(this.new_act.rows[i].total_with_nds);

        this.new_act.rows[i].total = this.toFixedFloat2(this.new_act.rows[i].count * this.new_act.rows[i].unit_price)
        this.new_act.rows[i].total_with_nds = this.toFixedFloat2(this.new_act.rows[i].total + this.new_act.rows[i].nds)

        // итог акта — по суммам строк (row_type '1'), а не заголовков;
        // если обычных строк нет — по заголовкам
        if (this.new_act.rows[i].row_type === '1') {
          line_total += this.new_act.rows[i].total;
          line_nds += this.new_act.rows[i].nds;
          line_twn += this.new_act.rows[i].total_with_nds;
          has_line_rows = true;
        } else if (this.new_act.rows[i].row_type === '2') {
          total += this.new_act.rows[i].total;
          nds += this.new_act.rows[i].nds;
          total_with_nds += this.new_act.rows[i].total_with_nds;
        }
      }

      this.new_act.total = this.toFixedFloat2(has_line_rows ? line_total : total);
      this.new_act.nds = this.toFixedFloat2(has_line_rows ? line_nds : nds);
      this.new_act.total_with_nds = this.toFixedFloat2(has_line_rows ? line_twn : total_with_nds);
    },
    mmg_row_totals(field) {
      // итог по строкам (row_type '1'); если их нет — по заголовкам ('2')
      const lines = this.new_act.rows.filter(j => j.row_type === '1');
      const src = lines.length ? lines : this.new_act.rows.filter(j => j.row_type === '2');
      return src.reduce((acc, row) => acc + Number(row[field] || 0.0), 0.0);
    },
    auto_calc_mmg(index, flag=0) {
      if (!this.vatReady) return;
      let total = 0.0;
      let nds = 0.0;
      let total_with_nds = 0.0;
      let line_total = 0.0;
      let line_nds = 0.0;
      let line_twn = 0.0;
      let has_line_rows = false;

      for (let i = 0; i < this.new_act.rows.length; i++) {
        let row = this.new_act.rows[i];
        if (row.count === '' || row.count < 0) {
          this.new_act.rows[i].count = 0.0;
        }
        if (row.unit_price === '' || row.unit_price < 0) {
          this.new_act.rows[i].unit_price = 0.0;
        }
        if (row.total === '' || row.total < 0) {
          this.new_act.rows[i].total = 0.0;
        }
        if (row.nds === '' || row.nds < 0) {
          this.new_act.rows[i].nds = 0.0;
        }
        if (row.total_with_nds === '' || row.total_with_nds < 0) {
          this.new_act.rows[i].total_with_nds = 0.0;
        }

        this.new_act.rows[i].count = this.toFixedFloat3(this.new_act.rows[i].count)
        this.new_act.rows[i].unit_price = this.toFixedFloat2(this.new_act.rows[i].unit_price);
        this.new_act.rows[i].total = this.toFixedFloat2(this.new_act.rows[i].total);
        this.new_act.rows[i].nds = this.toFixedFloat2(this.new_act.rows[i].nds);
        this.new_act.rows[i].total_with_nds = this.toFixedFloat2(this.new_act.rows[i].total_with_nds);

        if (index === i) {
          // flag 0: изменили количество / цену  -> пересчитываем стоимость, НДС, стоимость с НДС
          // flag 1: вручную изменили стоимость   -> пересчитываем НДС и стоимость с НДС
          // flag 2: вручную изменили НДС          -> пересчитываем стоимость с НДС
          // flag 3: вручную изменили стоимость с НДС -> оставляем как есть (ручной ввод)
          if (flag === 0) {
            this.new_act.rows[i].total = this.toFixedFloat2(this.toFixedFloat3(this.new_act.rows[i].count) * this.toFixedFloat2(this.new_act.rows[i].unit_price));
          }
          if (flag === 0 || flag === 1) {
            // Ставка подрядчика выбранного договора.
            this.new_act.rows[i].nds = this.toFixedFloat2(this.toFixedFloat2(this.new_act.rows[i].total) * this.profile_nds_rate());
          }
          if (flag === 0 || flag === 1 || flag === 2) {
            this.new_act.rows[i].total_with_nds = this.toFixedFloat2(this.toFixedFloat2(this.new_act.rows[i].total) + this.toFixedFloat2(this.new_act.rows[i].nds));
          }
        }

        // итог акта — по суммам строк (row_type '1'), а не заголовков;
        // если обычных строк нет — по заголовкам
        if (this.new_act.rows[i].row_type === '1') {
          line_total += this.new_act.rows[i].total;
          line_nds += this.new_act.rows[i].nds;
          line_twn += this.new_act.rows[i].total_with_nds;
          has_line_rows = true;
        } else if (this.new_act.rows[i].row_type === '2') {
          total += this.new_act.rows[i].total;
          nds += this.new_act.rows[i].nds;
          total_with_nds += this.new_act.rows[i].total_with_nds;
        }
      }

      this.new_act.total = this.toFixedFloat2(has_line_rows ? line_total : total);
      this.new_act.nds = this.toFixedFloat2(has_line_rows ? line_nds : nds);
      this.new_act.total_with_nds = this.toFixedFloat2(has_line_rows ? line_twn : total_with_nds);
    },
    auto_calc2() {
      if (!this.vatReady) return;
      let total_from_beg_year = 0.0;
      let total_from_beg_construction = 0.0;
      let total_current_month = 0.0;
      let total_nds = 0.0;
      let total_twn = 0.0;

      let rounding_flag = false;
      let negative_flag = false;
      for (let i = 0; i < this.new_act.rows_certs.length; i++) {
        let row = this.new_act.rows_certs[i];
        let from_beg_year = 0.0;
        let from_beg_construction = 0.0;
        let current_month = 0.0;

        if (row.from_beg_year !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.from_beg_year);
          row.from_beg_year = this.toFixedFloat2(row.from_beg_year);
          if (row.from_beg_year < 0) {
            row.from_beg_year = 0.0;
            negative_flag = true;
          }
          from_beg_year = row.from_beg_year;
        }
        if (row.from_beg_construction !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.from_beg_construction);
          row.from_beg_construction = this.toFixedFloat2(row.from_beg_construction);
          if (row.from_beg_construction < 0) {
            row.from_beg_construction = 0.0;
            negative_flag = true;
          }
          from_beg_construction = row.from_beg_construction;
        }

        if (row.current_month !== '') {
          rounding_flag = rounding_flag || this.isPartitive2(row.current_month);
          row.current_month = this.toFixedFloat2(row.current_month);
          if (row.current_month < 0) {
            row.current_month = 0.0;
            negative_flag = true;
          }
          current_month = row.current_month;
        }

        // Первая строка справки получает сумму НДС из акта приемки, включая ручной ввод.
        const acceptance_nds = Number(this.new_act.accmini_nds);
        const use_acceptance_nds = this.new_act.type === 3 &&
          this.new_act.dbikrs_inner_type === 'Бурение' && i === 0 &&
          current_month === Number(this.new_act.accmini_total) && Number.isFinite(acceptance_nds);
        row.nds = use_acceptance_nds
          ? this.toFixedFloat2(Math.max(0, acceptance_nds))
          : this.toFixedFloat2(current_month * this.profile_nds_rate());
        row.total_with_nds = this.toFixedFloat2(row.nds + current_month);

        total_from_beg_year += from_beg_year;
        total_from_beg_construction += from_beg_construction;
        total_current_month += current_month;
        total_nds += row.nds;
        total_twn += row.total_with_nds;
      }

      this.new_act.total_from_beg_year = total_from_beg_year;
      this.new_act.total_from_beg_construction = total_from_beg_construction;
      this.new_act.total_current_month = total_current_month;
      this.new_act.total_nds = total_nds;
      this.new_act.total_twn = total_twn;

      // this.new_act.nds_from_beg_construction = this.toFixedFloat2(this.new_act.total_from_beg_construction * 0.12);
      // this.new_act.nds_contract_total = this.toFixedFloat2(this.new_act.total_contract_total * 0.12);
      // this.new_act.nds_current_month = this.toFixedFloat2(this.new_act.total_current_month * 0.12);
      //
      // this.new_act.twn_from_beg_construction = this.toFixedFloat2(this.new_act.total_from_beg_construction + this.new_act.nds_from_beg_construction);
      // this.new_act.twn_contract_total = this.toFixedFloat2(this.new_act.total_contract_total + this.new_act.nds_contract_total);
      // this.new_act.twn_current_month = this.toFixedFloat2(this.new_act.total_current_month + this.new_act.nds_current_month);

      if (rounding_flag && negative_flag) {
        // alert('1. Значения в числовых ячейках не могут быть < 0; 2. Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Значения не могут быть меньше нуля. Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (rounding_flag) {
        // alert('Все значения в числовых ячейках округляются до 2 (двух) знаков после запятой');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Все значения округляются до 2 (двух) знаков после запятой',
          })
      } else if (negative_flag) {
        // alert('Значения в числовых ячейках не могут быть отрицательными значениями');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Значения в числовых ячейках не могут быть отрицательными значениями',
          })
      }
    },
    auto_calc3() {
      if (!this.vatReady) return;
      let accmax_total = 0.0;
      for (let i = 0; i < this.new_act.rows_accmax.length; i++) {
        accmax_total += this.toFixedFloat2(this.new_act.rows_accmax[i].total);
      }

      this.new_act.accmax_total = accmax_total;
      this.new_act.accmax_nds = this.toFixedFloat2(accmax_total * this.profile_nds_rate());
      this.new_act.accmax_total_with_nds = this.toFixedFloat2(accmax_total + this.new_act.accmax_nds);
    },
    auto_calc_supervisor() {
      if (!this.vatReady) return;
      // ДБиКРС-Супервайзер (задача #47): стоимость = тариф × часы,
      // НДС по ставке из профиля.
      let tariff = Number(this.new_act.dbikrs_unit_price) || 0;
      let total = 0.0;
      for (let i = 0; i < this.new_act.rows_supervisor.length; i++) {
        let row = this.new_act.rows_supervisor[i];
        row.cost = this.toFixedFloat2((Number(row.hours) || 0) * tariff);
        total += row.cost;
      }
      this.new_act.total = this.toFixedFloat2(total);
      this.new_act.nds = this.toFixedFloat2(total * this.profile_nds_rate());
      this.new_act.total_with_nds = this.toFixedFloat2(total + this.new_act.nds);
    },
    add_row_supervisor() {
      this.new_act.rows_supervisor.push({
        work_name: '', well_number: '', supervisor_count: 1,
        worked_period: '', days_count: 0.0, hours: 0.0, cost: 0.0,
      });
    },
    rm_row_supervisor() {
      this.new_act.rows_supervisor.pop();
    },
    change_ptopd_type() {
      // ПТО ПД (задачи #57/#58): при выборе подтипа заводим стартовую строку
      // и называем шаг 3 по форме подтипа (вместо безликой «Таблицы»).
      let step3 = null;
      if (this.new_act.ptopd_inner_type === 'Перевозка насосов') {
        if (this.new_act.rows_pump.length === 0) this.add_row_pump();
        step3 = {
          name: 'Акт (насосы)',
          instruction: 'На данном шаге заполните строки акта выполненных работ по завозу и вывозу насосов (за отчетный период и с начала года)',
        };
      } else if (this.new_act.ptopd_inner_type === 'Химизация') {
        if (this.new_act.rows_chem.length === 0) this.add_row_chem();
        step3 = {
          name: 'Акт (химизация)',
          instruction: 'На данном шаге заполните строки акта выполненных работ по химизации: тонны и стоимость, сумма рассчитывается автоматически',
        };
      } else {
        if (this.new_act.rows_prs.length === 0) this.add_row_prs();
        step3 = {
          name: 'Акт (ПРС)',
          instruction: 'На данном шаге укажите стоимость 1 бригадо-часа и заполните строки акта приемки законченных подземным ремонтом скважин',
        };
      }
      const params = this.all_steps[0];
      const attach = this.all_steps[1];
      this.all_steps = [params, attach, {
        name: 'Форма Р-1',
        instruction: 'На данном шаге заполните строки формы Р-1 (акта выполненных работ): наименование работ (услуг), количество, цена и стоимость',
      }, step3];
    },
    auto_calc_chem() {
      if (!this.vatReady) return;
      // ПТО ПД-Химизация (задача #58): сумма вводится напрямую (рабочие колонки
      // тн/стоимость из доп. форм не входят в акт); ИТОГО предзаполняется по
      // строкам, но может быть введено вручную, как и «Всего с НДС».
      let total = 0.0;
      for (let i = 0; i < this.new_act.rows_chem.length; i++) {
        total += Number(this.new_act.rows_chem[i].amount) || 0;
      }
      this.new_act.total = this.toFixedFloat2(total);
      this.chem_totals_from_total();
    },
    chem_totals_from_total() {
      if (!this.vatReady) return;
      let total = Number(this.new_act.total) || 0;
      this.new_act.nds = this.toFixedFloat2(total * this.profile_nds_rate());
      this.new_act.total_with_nds = this.toFixedFloat2(total + this.new_act.nds);
    },
    add_row_chem() {
      this.new_act.rows_chem.push({
        act_number: '', shop: '', area: '', chem_name: '', well: '',
        tons: 0.0, unit_price: 0.0, amount: 0.0,
      });
    },
    rm_row_chem() {
      this.new_act.rows_chem.pop();
    },
    auto_calc_prs() {
      if (!this.vatReady) return;
      // ПТО ПД-ПРС: сумма = тариф × оплаченное время, НДС по ставке из профиля.
      let tariff = Number(this.new_act.ptopd_unit_price) || 0;
      let total = 0.0;
      for (let i = 0; i < this.new_act.rows_prs.length; i++) {
        let row = this.new_act.rows_prs[i];
        row.cost = this.toFixedFloat2((Number(row.payed_time) || 0) * tariff);
        total += row.cost;
      }
      this.new_act.total = this.toFixedFloat2(total);
      this.new_act.nds = this.toFixedFloat2(total * this.profile_nds_rate());
      this.new_act.total_with_nds = this.toFixedFloat2(total + this.new_act.nds);
    },
    add_row_prs() {
      this.new_act.rows_prs.push({
        brigade_number: '', well_number: '', se: '', shop: '', repair_type: '',
        started_date: '', ended_date: '', fact_time: 0.0, payed_time: 0.0, unpaid_time: 0.0, cost: 0.0,
      });
    },
    rm_row_prs() {
      this.new_act.rows_prs.pop();
    },
    auto_calc_pump() {
      if (!this.vatReady) return;
      // ПТО ПД-Перевозка насосов: сумма по акту = сумма за отчётный период,
      // НДС по ставке из профиля.
      let total = 0.0;
      for (let i = 0; i < this.new_act.rows_pump.length; i++) {
        total += Number(this.new_act.rows_pump[i].sum_period) || 0;
      }
      this.new_act.total = this.toFixedFloat2(total);
      this.new_act.nds = this.toFixedFloat2(total * this.profile_nds_rate());
      this.new_act.total_with_nds = this.toFixedFloat2(total + this.new_act.nds);
    },
    add_row_pump() {
      this.new_act.rows_pump.push({
        field_name: '', trips_period: 0.0, pumps_period: 0.0, sum_period: 0.0,
        trips_year: 0.0, pumps_year: 0.0, sum_year: 0.0,
      });
    },
    rm_row_pump() {
      this.new_act.rows_pump.pop();
    },
    auto_calc_krs_total(index) {
      if (!this.vatReady) return;
      let row = this.new_act.rows_accmax[index];
      row.total = this.toFixedFloat2((row.payed_time || 0) * (this.new_act.dbikrs_unit_price || 0));
      this.auto_calc3();
    },
    auto_calc_krs_all() {
      if (!this.vatReady) return;
      for (let i = 0; i < this.new_act.rows_accmax.length; i++) {
        let row = this.new_act.rows_accmax[i];
        row.total = this.toFixedFloat2((row.payed_time || 0) * (this.new_act.dbikrs_unit_price || 0));
      }
      this.auto_calc3();
    },
    monthDiff(d1, d2) {
      var months;
      months = (d2.getFullYear() - d1.getFullYear()) * 12;
      months -= d1.getMonth();
      months += d2.getMonth();
      return months <= 0 ? 0 : months;
    },
    check_act_date() {
      let today = new Date();
      let act_date = new Date(this.new_act.act_date)

      if (this.monthDiff(act_date, today) > 2 || this.monthDiff(today, act_date) > 2) {
        this.$store.dispatch('addNotification', {
          type: 'warning',
          message: "Предупреждение: " + 'Дата акта отличается от текущей даты больше чем на 2 месяца',
        });
      }
    },
    reuploadVl1() {
      // const file = this.$refs.file.files[0];
      let fileName = document.getElementById("input-field-multiple").value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();


      if (!(extFile === "png" || extFile === "pdf" || extFile === "jpg" || extFile === "jpeg" || extFile === "xls" || extFile === "xlsx" || extFile === "zip" || extFile === "rar")) {
        this.$modal.show("file-modal-multiple");
        this.file = null;
      } else {
        this.new_act.uploading = true;
      }
    },
    reuploadVl_d1(index) {
      let fileName = document.getElementById("input-field-d1-" + index).value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

      if (!(extFile === "png" || extFile === "jpg" || extFile === "jpeg")) {
        this.$modal.show("file-modal-d1-" + index);
        this.file = null;
      } else {
        this.new_act.double_files[index].uploading_d1 = true;
      }
    },
    reuploadVl_d2(index) {
      // const file = this.$refs['file_d2_' + index].files[0];
      let fileName = document.getElementById("input-field-d2-" + index).value,
          idxDot = fileName.lastIndexOf(".") + 1,
          extFile = fileName.substr(idxDot, fileName.length).toLowerCase();

      if (!(extFile === "png" || extFile === "jpg" || extFile === "jpeg")) {
        this.$modal.show("file-modal-d2-" + index);
        this.file = null;
      } else {
        this.new_act.double_files[index].uploading_d2 = true;
      }
    },
    closeModalMultuple() {
      this.$modal.hide("file-modal-multiple");
    },
    closeModalD1(index) {
      this.$modal.hide("file-modal-d1-" + index);
    },
    closeModalD2(index) {
      this.$modal.hide("file-modal-d2-" + index);
    },
    add_double_file() {
      let a = {
        uploading_d1: false,
        uploading_d2: false
      };
      this.new_act.double_files.push(a);
    },
    change_row_date_type() {
      let row_date_type_element = document.getElementById('row-date-type');
      this.row_date_type = row_date_type_element.value;
    },
    change_row_type() {
      let row_type_element = document.getElementById('row-type');
      this.row_type = row_type_element.value;
    },
    change_row_date_type3() {
      let row_date_type_element = document.getElementById('row-date-type3');
      this.row_date_type = row_date_type_element.value;
    },
    change_row_date_type_template() {
      let row_date_type_element = document.getElementById('row-date-type-template');
      this.row_date_type_template = row_date_type_element.value;
    },
    change_row_accept_type() {
      let row_accept_type_element = document.getElementById('row-accept-type');
      this.row_accept_type = row_accept_type_element.value;
    },
    add_row() {
      let double_date = true;
      if (this.row_date_type === '' && this.row_type === ''  && this.new_act.type !== 2) {
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Выберите тип даты и тип строки',
          })
        return;
      }
      if (this.row_type !== '2' && this.new_act.rows.length === 0) {
        this.$store.dispatch('addNotification', {
          type: 'warning',
          message: "Предупреждение: " + 'Первая строка должна быть типа "Заголовок"',
        })
        return;
      }
      if (this.new_act.rows.length > 0) {
        if (this.row_type === '2' && this.new_act.rows[this.new_act.rows.length - 1].row_type === '2') {
          this.$store.dispatch('addNotification', {
            type: 'warning',
            message: "Предупреждение: " + 'Нельзя добавлять две строки типа "Заголовок" подряд',
          })
          return;
        }
      }

      if (this.row_date_type === '1') {
        double_date = false;
      }
      let row = {
        cost_code: '',
        mvz_code: '',
        source_code: '',
        mvz_name: '',
        row_type: this.row_type,
        work_name: '',
        double_date: double_date,
        start_date: '',
        end_date: '',
        row_date: '',
        research_report: '',
        measure_unit: 'услуга',
        count: 0.0,
        unit_price: 0.0,
        total: 0.0,
        reason: '',
        reason_cost: 0.0,
        nds: 0.0,
        total_with_nds: 0.0,
        val1: this.row_type === '1' ? 'Код цеха' : '',
        val2: '',
        val3: 'Код партии',
        val4: '',
        val5: '',
        val6: 'Код объекта',
        val7: '',
        val8: '',
        val9: '',
        val10: '',
        val11: '',
        val12: '',
      };
      this.new_act.rows.push(row);
      this.row_date_type = '1';
      this.$modal.hide("add-row-modal");
    },
    add_row_cert() {
      if (this.new_act.type === 1) {
        // alert('Ошибка типа акта');
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: 'Ошибка: ' + 'Ошибка типа акта',
          })
        return;
      }
      let row = {
        work_name: '',
        from_beg_year: '',
        from_beg_construction: '',
        current_month: '',
        constr_install: '',
        other_expenses: '',
        constr_install_month: '',
        install_furniture: '',
        additional_costs: '',
        materials_purchase: '',
        nds: '',
        total_with_nds: ''
      };
      if (this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Бурение' && this.new_act.rows_certs.length === 0) {
        row.current_month = this.new_act.accmini_total || '';
      }
      this.new_act.rows_certs.push(row);
      if (this.new_act.type === 3 && this.new_act.dbikrs_inner_type === 'Бурение') {
        this.auto_calc2();
      }
    },
    add_row_transc() {
      if (this.new_act.type !== 2) {
        // alert('Ошибка типа акта');
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: 'Ошибка: ' + 'Ошибка типа акта',
          })
        return;
      }
      let row = {
        work_name: '',
        measure_unit: '',
        plan_count: 0.0,
        plan_total: 0.0,
        plan_impl_total: 0.0,
        current_month_count: 0.0,
        current_month_total: 0.0,
        current_month_impl_total: 0.0,
        beg_contract_count: 0.0,
        beg_contract_total: 0.0,
        beg_contract_impl_total: 0.0,
        plan_remainder_count: 0.0,
        plan_remainder_total: 0.0,
        plan_remainder_impl_total: 0.0,

      };
      this.new_act.rows_transc.push(row);
    },
    add_row_accmini() {
      if (this.new_act.type !== 3) {
        // alert('Ошибка типа акта');
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: 'Ошибка: ' + 'Ошибка типа акта',
          })
        return;
      }
      let row = {
        work_name: '',
        link_text: '',
        total: 0.0,

      };
      this.new_act.rows_accmini.push(row);
    },
    add_row_accmax() {
      if (this.new_act.type !== 3) {
        // alert('Ошибка типа акта');
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: 'Ошибка: ' + 'Ошибка типа акта',
          })
        return;
      }

      const filtered = this.new_act.rows_accmax.filter(r => r.parent_sort_number === 0);

      const maxSort = filtered.length
          ? Math.max(...filtered.map(r => r.sort_number))
          : 0;   // или любое дефолтное значение

      const filtered_max_number = this.new_act.rows_accmax.length;

      let row = {
        sort_number: maxSort + 1,
        serial_number: filtered_max_number + 1,
        display_number: String(maxSort + 1),
        work_name: '',
        shop_number: '',
        well_number: '',
        started_date: '',
        ended_date: '',
        parent_sort_number: 0,
        fact_time: 0.0,
        unv_time: 0.0,
        payed_time: 0.0,
        total: 0.0,
      };
      this.new_act.rows_accmax.push(row);
    },
    add_row_accmax_inner(index) {
      if (this.new_act.type !== 3) {
        // alert('Ошибка типа акта');
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: 'Ошибка: ' + 'Ошибка типа акта',
          })
        return;
      }
      function getLeftParentSort(rows, index) {
        for (let i = index; i >= 0; i--) {
          if (rows[i].parent_sort_number === 0) {
            return rows[i].sort_number;
          }
        }
        return 0; // если слева нет ни одного parent=0
      }

      const result = getLeftParentSort(this.new_act.rows_accmax, index);

      let row = {
        sort_number: result,
        serial_number: index + 2,
        display_number: '',
        work_name: '',
        shop_number: '',
        well_number: '',
        started_date: '',
        ended_date: '',
        parent_sort_number: result,
        fact_time: 0.0,
        unv_time: 0.0,
        payed_time: 0.0,
        total: 0.0,
      };
      for (let i = index + 1; i < this.new_act.rows_accmax.length; i++) {
        this.new_act.rows_accmax[i].serial_number = this.new_act.rows_accmax[i].serial_number + 1
      }
      this.new_act.rows_accmax.push(row);
      this.new_act.rows_accmax.sort((a, b) => a.serial_number - b.serial_number);
      console.log(this.new_act.rows_accmax);
    },
    add_row_accept() {
      if (this.row_accept_type === '' || this.new_act.type !== 2) {
        // alert('Выберите тип строки акта');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Выберите тип строки акта',
          })
        return;
      }
      if (this.row_accept_count === '' || this.new_act.type !== 2) {
        // alert('Выберите количество строк');
        this.$store.dispatch('addNotification', {
              type: 'warning',
              message: "Предупреждение: " + 'Выберите количество строк',
          })
        return;
      }


      for (let i=0; i<this.row_accept_count; i++) {
        let serial_i = 0;
        if (this.row_accept_type === 'Двойная строка') {
          serial_i = this.curr_serial;
          this.curr_serial += 1;
        }
        let row = {
          serial_number: serial_i,
          type: this.row_accept_type,

          work_name: '',

          source_code: '',
          measure_unit: '',
          count: '',
          count_percent: false,

          unit_all: '',
          unit_car: '',
          unit_salary: '',
          unit_salary_car: '',

          total_all: '',
          total_car: '',
          total_material: '',
          total_salary: '',
          total_salary_car: '',
          total_furniture: '',

          overheads: '',
          estimated_profit: '',

          cost_total: '',
        };
        this.new_act.rows_accept.push(row);
      }
      this.row_accept_type = '';
      this.row_accept_count = 1;
      this.$modal.hide("add-row-accept-modal");
    },
    rm_row() {
      this.new_act.rows.pop();
      this.auto_calc();
    },
    rm_row_index(index) {
      this.new_act.rows.splice(index, 1);
      this.auto_calc();
    },
    rm_row_cert() {
      this.new_act.rows_certs.pop();
    },
    rm_row_accmax() {
      this.new_act.rows_accmax.pop();
    },
    rm_row_transc() {
      this.new_act.rows_transc.pop();
    },
    rm_row_accmini() {
      this.new_act.rows_accmini.pop();
    },
    rm_row_accept() {
      this.new_act.rows_accept.pop();
    },
    getMyContracts() {
      this.$store.dispatch("getMyContracts").then((response) => {
        this.contracts = response.data;
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        })
      });
    },
    getCostList() {
      this.$store.dispatch("getCostList").then((response) => {
        this.cost_list = response.data;
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        })
      });
    },
    getMVZList() {
      this.$store.dispatch("getMVZList").then((response) => {
        this.mvz_list = response.data;
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        })
      });
    },
    downloadTemplate() {
      let formData = {
        template_row_count: this.template_row_count,
        template_header_count: this.template_header_count || 1,
      };
      this.$store.dispatch("downloadTemplate", formData).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'AVR_Template.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        })
      });
    },
    downloadTemplateDKSRF() {
      let formData = {
        template_row_count: this.template_row_count
      };
      this.$store.dispatch("downloadTemplateDKSRF", formData).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Шаблон_для_загрузки_Расшифровки.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        })
      });
    },
    showAddRowModal() {
      this.$modal.show("add-row-modal");
    },
    showDownloadTemplate() {
      this.$modal.show("download-template-modal");
    },
    showDownloadTemplateDKSRF() {
      this.$modal.show("download-template-modal-dks-rf");
    },
    showDownloadTemplateKRS() {
      this.$modal.show("download-template-modal-krs");
    },
    downloadTemplateKRS() {
      let formData = { template_row_count: this.template_row_count };
      this.$store.dispatch("downloadTemplateKRS", formData).then((response) => {
        const url = URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'Шаблон_КРС.xlsx');
        document.body.appendChild(link);
        link.click();
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        });
      });
    },
    uploadTemplateKRS() {
      let formData = new FormData();
      let file = this.$refs['file_template_krs'].files[0];
      formData.append('file_template', file);
      this.$store.dispatch('uploadTemplateKRS', formData).then((response) => {
        this.new_act.rows_accmax = response.data.rows;
        this.krsTableKey++;
        this.auto_calc3();
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
          type: 'error',
          message: error.response.data.detail,
        });
      });
    },
    showAddRowAcceptModal() {
      this.$modal.show("add-row-accept-modal");
    },
    prettyPrice(price) {
      if (typeof price === "number") {
        return price
            .toFixed(2)
            .replace(/\d(?=(\d{3})+\.)/g, "$& ");
      } else {
        return price;
      }
    },
    parseFormattedNum(str) {
      return parseFloat(String(str).replace(/\s/g, '').replace(',', '.')) || 0;
    },
    createAct() {
      if (!this.requireVatRate()) return;
      let formData = new FormData();

      console.log(this.$refs);
      console.log('files_additional');
      console.log(this.$refs['files_additional']);
      for (let i = 0; i < this.$refs['files_additional'].files.length; i++) {
        let file = this.$refs['files_additional'].files[i];
        formData.append('files_additional-' + i, file);
      }

      for (let i = 0; i < this.new_act.double_files.length; i++) {
        let double_file = this.new_act.double_files[i];
        if (double_file.uploading_d1 && double_file.uploading_d2) {
          let file_d1 = this.$refs['file_d1_' + i][0].files[0];
          let file_d2 = this.$refs['file_d2_' + i][0].files[0];
          formData.append('file_d1-' + i, file_d1);
          formData.append('file_d2-' + i, file_d2);
        }
      }

      // formData.append('file', this.file);
      const json = JSON.stringify(this.new_act);

      formData.append('new_act', json);
      console.log('formData');
      console.log(formData);
      this.$store.dispatch('createAct', formData).then((response) => {
        console.log(response.data.act_id);
        if (response.data.act_id !== '') {
          router.push({name: 'actview', params: {id: response.data.act_id}});
        } else {
          // alert('Ошибка');
          this.$store.dispatch('addNotification', {
              type: 'error',
              message: response.data.detail,
          })
        }
      }).catch((error) => {
        // alert(error);
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: error.response.data.detail,
          })
      });
    },
    uploadTemplate() {
      let formData = new FormData();


      let file = this.$refs['file_template'].files[0];
      console.log('file');
      console.log(file);
      formData.append('file_template', file);

      this.$store.dispatch('uploadTemplate', formData).then((response) => {
        console.log('success');
        console.log(response.data);
        this.new_act.rows = response.data.rows;
        this.auto_calc_mmg_global();
        // if (response.data.act_id !== '') {
        //   router.push({name: 'actview', params: {id: response.data.act_id}});
        // } else {
        //   // alert('Ошибка');
        //   this.$store.dispatch('addNotification', {
        //       type: 'error',
        //       message: 'Ошибка, попробуйте заново',
        //   })
        // }
      }).catch((error) => {
        // alert(error);
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: error.response.data.detail,
          })
      });
    },
    uploadTemplateGalaktika() {
      let formData = new FormData();

      let file = this.$refs['file_template_galaktika'].files[0];
      formData.append('file_template', file);

      return this.$store.dispatch('uploadTemplateGalaktika', formData).then(async (response) => {
        // Не заменяем строки и не считаем НДС, пока ставка договора не загружена.
        if (!this.vatReady) {
          await this.loadVatRate(this.vatSelectedContractId);
        }
        if (!this.requireVatRate()) return;
        this.new_act.rows = response.data.rows;
        // НДС из файла не используем — считаем по ставке из профиля подрядчика
        this.new_act.rows.forEach(row => {
          row.total = this.toFixedFloat2(this.toFixedFloat3(row.count) * this.toFixedFloat2(row.unit_price));
          row.nds = this.toFixedFloat2(row.total * this.profile_nds_rate());
        });
        this.auto_calc_mmg_global();
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: 'Загружено позиций из Галактики: ' + response.data.rows.length,
        })
      }).catch((error) => {
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: error.response.data.detail,
          })
      });
    },
    uploadTemplateDKSRF() {
      let formData = new FormData();


      let file = this.$refs['file_template'].files[0];
      console.log('file');
      console.log(file);
      formData.append('file_template', file);

      this.$store.dispatch('uploadTemplateDKSRF', formData).then((response) => {
        console.log('success');
        console.log(response.data);
        this.new_act.rows_transc = response.data.rows;
        // this.auto_calc_mmg();
        // if (response.data.act_id !== '') {
        //   router.push({name: 'actview', params: {id: response.data.act_id}});
        // } else {
        //   // alert('Ошибка');
        //   this.$store.dispatch('addNotification', {
        //       type: 'error',
        //       message: 'Ошибка, попробуйте заново',
        //   })
        // }
      }).catch((error) => {
        // alert(error);
        this.$store.dispatch('addNotification', {
              type: 'error',
              message: error.response.data.detail,
          })
      });
    },
    curr_class(arg) {
      if (this.curr_module === arg) {
        return 'current';
      } else if (this.curr_module > arg) {
        return 'done';
      }
      return '';
    },
    getFilesHiddenClass(curr_mod) {
      console.log('curr_module');
      console.log(curr_mod);
      if (curr_mod !== 2) {
        return 'hidden-element';
      }
      return '';
    },
    prevStep() {
      if (this.curr_module > 1) {
        this.curr_module -= 1;
      }
    },
    nextStep() {
      if (!this.requireVatRate()) return;
      if (this.new_act.type === 1) {
        if (this.curr_module < 3) {
          this.curr_module += 1;
        } else {
          this.createAct();
        }
      } else if (this.new_act.type === 2) {
        if (this.curr_module === 4 && this.new_act.inner_type === 'Капстроительство') {
          this.createAct();
        } else if (this.curr_module === 5) {
          this.createAct();
        } else if (this.curr_module < this.all_steps.length) {
          this.curr_module += 1;
        }
      } else if (this.new_act.type === 3) {
        if (this.curr_module === 4) {
          this.createAct();
        } else if (this.curr_module < this.all_steps.length) {
          this.curr_module += 1;
        }
      } else if (this.new_act.type === 4) {
        if (this.curr_module === 4) {
          this.createAct();
        } else if (this.curr_module < this.all_steps.length) {
          this.curr_module += 1;
        }
      }
    },
    prev_next_btn_class() {
      if (this.curr_module === 1) {
        return 'flex-end';
      } else {
        return 'flex-space-between';
      }
    },
    get_arrow_steps_class() {
      if (this.new_act.type === 1) {
        return 'arrow-steps';
      } else {
        return 'arrow-steps-short';
      }
    }
  }
}
</script>

<style scoped>
@import "../assets/css/Nunito.css";
@import "../assets/css/josefin.css";

*,
*::after,
*::before {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Nunito", sans-serif;
}

.upload-from-xls {
  padding: 0.3rem 0.7rem 0.3rem 0.7rem;
  background-color: #00aacc;
  color: white;
  border-radius: 5px;
}

.hidden-element {
  display: none !important;
}

.required-cell {
  /*  */
}

select {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

.m-table-act {
  width: 100%;

  text-align: center;
  font-size: x-small;
  border: 1px solid black;
  border-collapse: collapse;
}

.m-table-act td {
  border: 1px solid black;
  border-collapse: collapse;
}

.m-table-act th {
  -moz-transition: all 1s ease-out;
  -o-transition: all 1s ease-out;
  -webkit-transition: all 1s ease-out;
  border: 1px solid black;
  border-collapse: collapse;
}

.input-field-default {
  width: 100%;
  padding: 10px;
  border: 1px solid gray;
  text-align: center;
  font-size: 1rem;
  outline: none;
  margin: 0.5rem 0 1rem;
  border-radius: 10px;
}

.input-field-template {
  width: 300px !important;
  padding: 10px;
  border: 1px solid gray;
  text-align: center;
  font-size: 1rem;
  outline: none;
  margin: 0.5rem 0 1rem;
  border-radius: 10px;
}

.inputfile {
  /* visibility: hidden etc. wont work */
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.inputfile:focus + label {
  /* keyboard navigation */
  outline: 1px dotted #000;
  outline: -webkit-focus-ring-color auto 5px;
}

.inputfile + label * {
  pointer-events: none;
}

.no-border-right {
  border-right: none !important;
  border-top: none !important;
  border-bottom: none !important;
}

.m-input-cell {
  width: 100%;
  /*border-width: 1px;*/
  height: 35px;
  text-align: center;
}

.m-textarea-cell {
  display: block;
  width: 100%;
  padding: .5rem;
  /*border-width: 1px;*/
  height: 72px;
  text-align: left;
  resize: none;
}

.m-input-cell-big {
  display: block;
  width: 100%;
  /*border-width: 1px;*/
  height: 72px;
  text-align: center;
}

.dropzone {
  /*margin-top: 3rem;*/
  height: 250px;
  min-height: 250px;
  padding: 10px;
  position: relative;
  cursor: pointer;
  border: 2px dashed gray;
  outline-offset: 10px;
  background: #d9e3f7;
  color: dimgray;
}

.input-field {
  opacity: 0;
  width: 100%;
  height: 100%;
  left: 0;
  position: absolute;
  cursor: pointer;
}

.dropzone:hover {
  background: lightblue;
  transition: all 300ms ease;
}

.dropzone .call-to-action {
  font-size: 1.5rem;
  text-align: center;
  padding: 70px 0;
}

.call-to-action > div {
  font-size: 1rem;
  padding: 1rem 2rem;
  background: #00aacc;
  max-width: 300px;
  margin: 1rem auto;
  border-radius: 20px;
  color: #fff;
}

.uploaded-msg {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.add_double_file {
  padding: .5rem;
  margin: .5rem;
  background: #23468c;
  color: white;
  border-radius: 10px;
}

.add_row_btn {
  padding: .5rem;
  margin: 1rem;
  background: #0c8;
  width: 2.6rem;
  font-size: 1rem;
  color: white;
  border-radius: 100%;
}

.rm_row_btn {
  padding: .5rem;
  margin: 1rem;
  background: rgba(255, 0, 0, 0.76);
  width: 2.6rem;
  font-size: 1rem;
  color: white;
  border-radius: 100%;
}

.rm_row_btn_small {
  /*padding: .5rem;*/
  margin: 0.4rem;
  background: rgba(255, 0, 0, 0.76);
  width: 1.5rem;
  font-size: 1rem;
  color: white;
  border-radius: 100%;
}

.rm_row_btn_small:hover {
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.3);
}

.modal-inner {
  height: 100%;
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
}

.modal-inner-short {
  padding: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  gap: 1rem;
  text-align: center;
}

@media only screen and (max-width: 1366px) {
  .title-img {
    width: 300px;
  }
}

.container {
  padding-right: 1.5rem;
  padding-left: 1.5rem;
  margin-right: auto;
  margin-left: auto;
  width: calc(100% - 3rem);
}

@keyframes wave {
  50% {
    transform: scale(0.9);
  }
}

.input-act-params {
  background: white;
  height: 60px;
  /*border: 1px solid gray;*/
  border-radius: .5rem;
  width: 100% !important;
  padding: 1rem;
}

input[type=checkbox] {
  appearance: none;
}

input[type=checkbox]:checked + label {
  border: 0.3rem solid #06aef0;
  box-shadow: 0 0 5px #333;
  opacity: 1;
}

.selected-items-wrapper {
  width: 300px;
  height: calc(100% - 300px);
  position: absolute;
  top: 300px;
  right: -300px;
  opacity: 0.8;
  padding: 1rem;
  overflow-y: auto;
  color: gray;
}

.selected-items-wrapper::-webkit-scrollbar {
  width: 13px;
  height: 13px;
}

.selected-items-wrapper::-webkit-scrollbar-track {
  border-radius: 15px;
}

.selected-items-wrapper::-webkit-scrollbar-thumb {
  border-radius: 100px;
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);
}

.categories-container {
  width: 100%;
}

.circle-number {
  border-radius: 300px;
  background: #23468c;
  color: #fff;
  float: left;
  font-size: 3rem;
  height: 80px;
  margin-right: 10px;
  margin-top: 5px;
  text-align: center;
  width: 80px;
  font-weight: bold;
  padding-top: 8px;
}

.module-title {
  padding-top: 30px;
}

.clearfix:after {
  clear: both;
  content: "";
  display: block;
  height: 0;
  background: inherit;
}

.wizard-nav {
  width: 100%;
  margin-bottom: 1rem;
}

a, a:active {
  color: #333;
  text-decoration: none;
}

a:hover {
  color: #999;
}

/* ── Step wizard ─────────────────────────────────── */
.arrow-steps,
.arrow-steps-short {
  display: flex;
  width: 100%;
  align-items: stretch;
}

.arrow-steps .step,
.arrow-steps-short .step {
  flex: 1;
  min-width: 0;
  height: 54px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  padding: 0 .75rem 0 2rem;
  position: relative;
  background-color: #dce6f5;
  color: #4a5568;
  font-size: 13px;
  cursor: default;
  user-select: none;
  transition: background-color 0.2s ease, color 0.2s ease;
  overflow: hidden;
}

/* right arrow */
.arrow-steps .step::after,
.arrow-steps-short .step::after {
  content: '';
  position: absolute;
  right: -27px;
  top: 0;
  width: 0;
  height: 0;
  border-top: 27px solid transparent;
  border-bottom: 27px solid transparent;
  border-left: 27px solid #dce6f5;
  z-index: 2;
  transition: border-color 0.2s ease;
}

/* left notch */
.arrow-steps .step::before,
.arrow-steps-short .step::before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 0;
  height: 0;
  border-top: 27px solid transparent;
  border-bottom: 27px solid transparent;
  border-left: 27px solid #e4e9f7;
  z-index: 1;
}

.arrow-steps .step:first-child,
.arrow-steps-short .step:first-child {
  padding-left: .75rem;
  border-radius: 8px 0 0 8px;
}

.arrow-steps .step:first-child::before,
.arrow-steps-short .step:first-child::before {
  border: none;
}

.arrow-steps .step:last-child,
.arrow-steps-short .step:last-child {
  border-radius: 0 8px 8px 0;
}

.arrow-steps .step:last-child::after,
.arrow-steps-short .step:last-child::after {
  border: none;
}

/* Done */
.arrow-steps .step.done,
.arrow-steps-short .step.done {
  background-color: #b3c9ea;
  color: #1e3a6e;
}

.arrow-steps .step.done::after,
.arrow-steps-short .step.done::after {
  border-left-color: #b3c9ea;
}

/* Current */
.arrow-steps .step.current,
.arrow-steps-short .step.current {
  background-color: #23468c;
  color: #fff;
}

.arrow-steps .step.current::after,
.arrow-steps-short .step.current::after {
  border-left-color: #23468c;
}

/* Badge circle */
.step-badge {
  flex-shrink: 0;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.35);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 700;
  z-index: 3;
  line-height: 1;
}

/* Step text block */
.step-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  z-index: 3;
  min-width: 0;
  overflow: hidden;
}

.step-num-label {
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: .5px;
  opacity: .7;
  white-space: nowrap;
}

.step-name-label {
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

</style>
